import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  'pt-BR': {
    translation: {
      common: {
        login: 'Login',
        logout: 'Sair',
        entrar: 'Começar minha liga',
        ranking: 'Ver ranking ao vivo',
        back: 'Voltar',
        previous: 'Anterior',
        next: 'Próximo',
        next_step: 'Próximo Passo',
        loading: 'Carregando...',
        saving: 'Salvando...',
        save_changes: 'Salvar Alterações',
        create_event: 'Criar Evento',
        read_more: 'Ler mais',
        view_details: 'Ver detalhes',
        coming_soon: 'Em breve',
        privacy: 'Privacidade',
        maintenance: 'Em Manutenção',
        close: 'Fechar',
        cancel: 'Cancelar',
        hours: 'Horas',
        days: 'Dias',
        day: 'Dia',
        race: 'Corrida',
        laps: 'Voltas',
        time: 'Tempo',
        upload: 'Upload',
        upload_image: 'Upload de Imagem',
        free: 'Grátis',
        paid_tokens: 'Pago (e-Tokens)',
        value: 'Valor',
        cross_platform: 'Cross-platform',
        success: 'Sucesso',
        error: 'Erro',
        pilot: 'Piloto',
        independent: 'Independente',
        independent_league: 'Liga Independente',
        error_saving: 'Erro ao salvar. Tente novamente.',
        error_loading: 'Erro ao carregar dados.',
        success_action: 'Ação realizada com sucesso!',
        fill_all_fields: 'Por favor, preencha todos os campos.'
      },
      marbles: {
        title: 'Saldo Marbles',
        wallet_button: 'Carteira Marbles',
        loading: 'Carregando...',
        error: 'Erro ao carregar o saldo',
        error_history: 'Erro ao carregar o extrato',
        retry: 'Tentar novamente',
        empty: 'Nenhuma movimentação ainda',
        history_title: 'Extrato',
        view_full: 'Ver extrato completo',
        private_note: 'Somente você pode ver este saldo',
        settings_tab: 'Carteira',
        settings_title: 'Carteira Marbles',
        settings_subtitle: 'Seu saldo e todas as movimentações da sua conta',
        tx: {
          deposit: 'Depósito',
          admin_grant: 'Crédito da plataforma',
          event_entry_fee: 'Taxa de inscrição',
          refund: 'Reembolso',
          event_prize: 'Prêmio de evento',
          platform_prize: 'Prêmio da plataforma',
          ecommerce_purchase: 'Compra no marketplace',
          withdrawal_hold: 'Saque em processamento',
          withdrawal_cancelled: 'Saque cancelado',
          admin_deduction: 'Ajuste da plataforma'
        }
      },
      pages: {
        landing: {
          upcomingEvents: 'Próximos Campeonatos',
          viewAllLeagues: 'Ver Todas as Ligas',
          registeredPilots: 'Pilotos Cadastrados',
          completedRaces: 'Corridas Realizadas',
          enterPlatform: 'Entrar na Plataforma'
        },
        dashboard: {
          overview: 'Visão Geral',
          myRegistrations: 'Minhas Inscrições',
          tokenBalance: 'Saldo de e-Tokens',
          seasonStats: 'Estatísticas da Temporada',
          nextRace: 'Próxima Corrida'
        },
        league: {
          about: 'Sobre a Liga',
          activeSeasons: 'Campeonatos Ativos',
          followers: 'Seguidores',
          follow: 'Seguir Liga',
          regulations: 'Regulamento Interno',
          organizedBy: 'Organizado por'
        },
        event: {
          openRegistrations: 'Inscrições Abertas',
          grid: 'Grid de Largada',
          briefing: 'Briefing de Corrida',
          allowedCars: 'Carros Permitidos',
          slotsRemaining: 'Vagas Restantes',
          register: 'Inscrever-se'
        },
        results: {
          saveResults: 'Salvar Resultados',
          publishStandings: 'Publicar Classificação',
          penalties: 'Penalidades Aplicadas',
          fastestLap: 'Volta Mais Rápida',
          disqualified: 'Desclassificado (DSQ)',
          uploadTelemetry: 'Carregar Telemetria'
        }
      },
      pwa: {
        install_ios: "Toque em Compartilhar e 'Adicionar à Tela de Início' para uma experiência nativa.",
        install_android: "Instale o e-MSS na sua tela inicial para acesso rápido.",
        install_button: "Instalar App",
        ios_alert: "Para instalar no iOS: toque no botão Compartilhar na barra inferior do Safari e selecione 'Adicionar à Tela de Início'."
      },
      maintenance: {
        pill: 'PIT STOP',
        eyebrow: 'Manutenção programada',
        title_top: 'EM',
        title_bottom: 'MANUTENÇÃO',
        lead: 'A plataforma está passando por uma intervenção técnica para levar o e-MSS ao próximo nível de performance. Seu piloto, seu rating e todo o seu histórico continuam intactos — voltamos em instantes.',
        status_value: 'Sistema fora de ar',
        clock_label: 'Relógio do paddock',
        cta_secondary: 'Falar com a equipe',
        note_title: 'Obrigado pela paciência',
        note_body: 'Resultados já lançados, ratings e Carteiras Safety não foram afetados. Dúvidas e reports continuam sendo atendidos no nosso Discord.',
        support: 'emsseries@gmail.com',
        footer_brand: 'e-Motorsport Series',
        footer_legal: 'Plataforma de Automobilismo Virtual'
      },
      landing: {
        hero: {
          season: 'PLATAFORMA GLOBAL DE AUTOMOBILISMO VIRTUAL',
          title: 'SUA CARREIRA NO SIMRACING EM UM SÓ LUGAR',
          subtitle: 'Construa seu rating eRS, conquiste licenças digitais e unifique seu histórico competitivo. Onde quer que você corra, seus resultados contam.',
          sim_racing: 'Console Sim Racing',
          fh6: 'Console Forza Horizon 6'
        },
        problem: {
          title: 'Correr sem histórico é andar em círculos',
          items: [
            'Corridas espalhadas em grupos de WhatsApp',
            'Resultados perdidos em planilhas antigas',
            'Incidentes resolvidos na discussão sem transparência',
            'Nenhum registro oficial para provar seu verdadeiro nível'
          ],
          closing: 'Seu talento merece um registro oficial. O padrão EMSS coloca o piloto no centro.'
        },
        stats: {
          pilots: 'Pilotos Ativos no Ranking',
          events: 'Corridas Realizadas',
          orgs: 'Ligas no Padrão EMSS'
        },
        sections: {
          events: 'Eventos em Aberto',
          ranking: 'Global Ranking',
          wallets: 'Carteiras Digitais',
          orgs: 'Ligas Parceiras'
        },
        feed: {
          title: 'COMPETIÇÕES AO VIVO',
          explore: 'Explorar eventos',
          drivers: 'pilotos',
          slots: 'vagas',
          final_phase: 'fase final'
        },
        value: {
          title: 'Quando o piloto evolui, o automobilismo virtual cresce',
          text: 'Com o eRS e a Carteira Safety, cada curva vale pontos para a sua carreira.\n\nPilotos motivados correm com mais frequência, respeitam a pista e buscam ligas estruturadas.\n\nÉ o piloto quem decide onde quer acelerar.',
          points: [
            'Rating eRS que atualiza a cada corrida',
            'Histórico de carreira unificado e eterno',
            'Stewarding profissional e Carteira Safety',
            'Grid nivelado por desempenho real'
          ]
        },
        trust: {
          title: 'Ligas que já adotaram o padrão EMSS'
        },
        pilot_path: {
          title: 'Cada volta constrói seu legado',
          subtitle: 'Sua carreira no e-Motorsport agora tem um registro oficial. Do kart ao protótipo, seu histórico te acompanha.',
          items: [
            {
              title: 'Licença Digital e-MSS',
              text: 'Sua carteira evolui conforme sua segurança e velocidade nas pistas da plataforma.'
            },
            {
              title: 'Global Rating eRS',
              text: 'O Electronic Rating System garante grids equilibrados contra pilotos do seu nível.'
            },
            {
              title: 'Histórico Eterno de Carreira',
              text: 'Acesse resultados de anos atrás em segundos. Sua história fica gravada para sempre.'
            }
          ]
        },
        segment: {
          pilot: {
            title: 'Para Pilotos',
            text: 'Construa sua reputação, acompanhe sua evolução em tempo real e dispute posições no ranking global.'
          },
          sponsor: {
            title: 'Para Patrocinadores & Marcas',
            text: 'Conecte sua empresa ao público apaixonado por velocidade e tecnologia com visibilidade real.',
            benefits: [
              'Exposição da marca em transmissões ao vivo, overlays e lobbies oficiais',
              'Acesso a dados de engajamento da comunidade ativa de SimRacing',
              'Naming rights de campeonatos, e-Tokens e troféus oficiais da plataforma',
              'Métricas transparentes de alcance e engajamento da audiência'
            ]
          },
          organizer: {
            title: 'Para Organizadores de Liga',
            text: 'Quando seus pilotos exigirem uma estrutura profissional, a plataforma EMSS entrega automação total e stewarding.'
          }
        },
        cta: {
          title: 'Sua carreira no e-Motorsport começa hoje',
          button: 'Criar meu perfil de piloto agora'
        }
      },
      login: {
        title: 'ENTRAR NA PISTA',
        subtitle: 'Acesse com sua conta Google para começar sua carreira virtual',
        google: 'Continuar com Google',
        terms: 'Ao entrar, você concorda com os Termos de Uso'
      },
      console: {
        dashboard: 'Dashboard',
        events: 'Eventos',
        results: 'Resultados',
        ranking: 'Ranking',
        garage: 'Garagem',
        settings: 'Configurações',
        stewardship: 'Comissão',
        help: 'Ajuda',
        online: 'Pilotos Online',
        rating: 'Seu eRS',
        track: 'Ir para a Pista',
        support: 'Suporte',
        logout: 'Sair',
        back_to_site: 'Voltar ao Site',
        search: 'Buscar eventos...',
        category: 'Categoria',
        license: 'Licença',
        game: 'Jogo',
        reset: 'Resetar Filtros',
        overview: 'Visão Geral',
        welcome: 'Bem-vindo de volta',
        next_event: 'PRÓXIMO EVENTO',
        all: 'TODOS',
        practice: 'PRÁTICA',
        qualifying: 'QUALIFYING',
        race: 'CORRIDA',
        my_leagues: 'MINHAS LIGAS',
        no_leagues_followed: 'Você ainda não segue nenhuma liga. Explore as ligas para receber atualizações.',
        game_selector_disabled: 'Seletor desabilitado nesta tela',
        cycle: {
          week: 'Semana',
          tooltip: '{{label}} — Semana {{week}} de {{total}}',
        },
        notifications: {
          title: 'Notificações',
          mark_all_read: 'Marcar todas como lidas',
          no_notifications: 'Nenhuma notificação nova',
          view_all: 'Ver todas',
          incident_reported: 'Incidente Reportado',
          verdict_published: 'Veredito Publicado',
          steward_assignment: 'Nova Atribuição',
          new_league: 'Nova Liga Criada',
          new_event: 'Novo Evento Criado',
          new_user: 'Novo Piloto Cadastrado'
        }
      },
      pilot_console: {
        safety_ers: 'eRS',
        driver_rank: 'Rank do Piloto',
        recommended: 'RECOMENDADO',
        confirmed: 'CONFIRMADO',
        registrations_open: 'INSCRIÇÕES ABERTAS',
        enter_server: 'Entrar no Servidor',
        no_highlight: 'Nenhum evento em destaque',
        time_to_green: 'Tempo até a Bandeira Verde',
        waiting_next: 'Aguardando Próximo Evento',
        days: 'DIAS',
        hours: 'HRS',
        minutes: 'MIN',
        seconds: 'SEG',
        races_completed: 'Corridas Realizadas',
        podiums: 'Pódios',
        avg_finish: 'Média Pos.',
        full_telemetry: 'Análise de Telemetria Completa',
        my_roster: 'Minhas Ligas',
        my_calendar: 'Meu Calendário',
        syncing: 'Sincronizando...',
        no_active_registrations: 'Nenhuma inscrição ativa',
        upcoming_races: 'Próximas Corridas',
        followed_leagues_races: 'LIGAS QUE VOCÊ SEGUE',
        community: 'COMUNIDADE',
        no_races_available: 'Nenhuma outra corrida disponível no momento',
        quick_links: 'Links Rápidos',
        discord_community: 'Comunidade Discord',
        race_regulations: 'Regulamentos de Corrida',
        pending_defenses: 'Defesas Pendentes',
        pending_defenses_desc: 'Protestos envolvendo você que aguardam sua atenção ou defesa dentro do prazo.',
        no_pending_defenses: 'Excelente! Você não possui defesas pendentes.',
        present_defense: 'Apresentar Defesa',
        defense_deadline_ended: 'Prazo encerrado',
        defense_alert_title: 'Atenção: você está com uma acusação pendente de defesa',
        defense_alert_desc: 'Uma ocorrência foi aberta contra você e ainda aguarda sua manifestação. Apresente sua defesa dentro do prazo para que a comissão possa analisar o caso ouvindo também o seu lado.',
        defense_time_remaining: 'restam {{hours}}h {{minutes}}min',
        defense_deadline_label: 'PRAZO PARA DEFESA',
        defense_deadline_warning: 'O prazo técnico para submissão de defesa encerrou em {{date}}. O formulário continua disponível: você ainda pode registrar sua versão dos fatos, mas a comissão avaliará um envio feito fora do prazo.',
        defense_deadline_warning_generic: 'O prazo técnico para submissão de defesa já encerrou. O formulário continua disponível: você ainda pode registrar sua versão dos fatos, mas a comissão avaliará um envio feito fora do prazo.',
        series_standings: 'Classificação das Séries',
        built_for_speed: 'Built for Speed.',
        date: 'Data',
        circuit: 'Circuito',
        enter_race: 'Entrar na Corrida',
        hot_topic: 'EM DESTAQUE',
        driver_dashboard: 'PAINEL DO PILOTO',
        race_started: 'CORRIDA EM ANDAMENTO',
        race_in_progress: 'CORRIDA EM ANDAMENTO',
        starts_in: 'COMEÇA EM',
        next_race: 'PRÓXIMA CORRIDA',
        view_details: 'Ver Detalhes',
        race_title: 'Título da Corrida',
        event: 'Evento',
        no_featured_event: 'Nenhum evento em destaque',
        cars: 'Carros',
        tracks: 'Pistas',
        cat: 'Cat.',
        dur: 'Dur.',
        lic: 'Lic.'
      },
      profile: {
        title: 'Perfil do Piloto',
        viewing_public: 'Visualizando Perfil Público',
        career: 'Carreira',
        stats: 'Estatísticas',
        integrations: 'Integrações',
        avgPos: 'Posição Média',
        sessions: 'Sessões',
        wins: 'Vitórias',
        podiums: 'Pódios',
        total: 'TOTAL',
        win_rate: 'TAXA DE VITÓRIA',
        podium_rate: 'TAXA DE PÓDIO',
        rank_label: 'RANKING',
        points_suffix: 'PTS',

        unlink: 'Desvincular',
        link: 'Vincular',
        unlink_confirm: 'Tem certeza que deseja desvincular seu Discord?',
        discord_success: 'Discord vinculado com sucesso!',
        accountDeactivated: 'Conta inativada com sucesso.',
        deactivateError: 'Erro ao inativar conta.',
        accountDeleted: 'Conta excluída permanentemente.',
        deleteError: 'Erro ao excluir conta.',
        no_races_found: 'Nenhuma corrida registrada.',
        history: 'Histórico de Corridas',
        license_history: 'Histórico de Licenças',
        rate: 'Taxa',
        become_request_hint: 'As solicitações de organizador e comissário são analisadas manualmente pela equipe de homologação.',
        global_points: 'Pontos Globais',
        track: 'Pista',
        career_path: 'Trilho de Carreira',
        milestone: 'MARCO',
        path_description: 'Continue participando de eventos homologados para subir no ranking global e desbloquear novas licenças.',
        become_organizer: 'Quero ser Organizador',
        become_steward: 'Quero ser Comissário',
        privacy_title: 'Privacidade e Segurança',
        account_mgmt_title: 'Gerenciamento de Conta (LGPD)',
        account_mgmt_desc: 'Você pode optar por <strong>inativar sua conta</strong> temporariamente (seus dados não serão exibidos publicamente) ou solicitar a <strong>exclusão permanente</strong> de seus dados pessoais, mantendo apenas informações anonimizadas para fins de integridade competitiva.',
        deactivate_account: 'Inativar Conta',
        deactivate_desc: 'Oculte seu perfil temporariamente. Seus dados e histórico serão preservados para quando você decidir voltar.',
        deactivate_btn: 'Sim, Inativar',
        delete_account: 'Excluir Dados',
        delete_desc: 'Exclua todos os seus dados pessoais permanentemente conforme a LGPD. Esta ação é irreversível.',
        delete_btn: 'Excluir Definitivamente',
        deactivate_confirm_title: 'Inativar Conta',
        deactivate_confirm_msg: 'Ao inativar sua conta, seu perfil deixará de ser visível em rankings e listas de pilotos. Seu histórico competitivo será mantido anonimamente. Você será desconectado da plataforma.',
        deactivate_confirm_btn: 'Sim, inativar',
        delete_confirm_title: 'Exclusão Permanente (LGPD)',
        delete_confirm_msg: 'Atenção: Esta ação é irreversível. Todos os seus dados pessoais (nome, links de redes sociais, e-mail) serão permanentemente excluídos de nossos servidores. Seu histórico de corridas será irreversivelmente anonimizado. Você será desconectado e não poderá recuperar esta conta.',
        delete_confirm_btn: 'EXCLUIR PERMANENTEMENTE',
        delete_confirm_word: 'EXCLUIR',
        table_date: 'Data',
        table_event: 'Evento',
        table_pos: 'Pos',
        table_sof: 'SoF',
        table_ers: 'eRS',
        connected: 'Conectado',
        cat_turismo: 'Turismo',
        cat_formula: 'Fórmula',
        cat_rally: 'Rally',
      },
      unauthorized: {
        title: 'Acesso Restrito',
        description: 'Apenas usuários com o cargo de Organizador podem criar novas ligas e eventos.',
        request_access: 'Solicitar Acesso',
        back_to_safety: 'Voltar para Segurança'
      },
      teams: {
        title: 'Equipes',
        create: 'Criar Equipe',
        create_title: 'Criação de Equipe',
        subtitle: 'Gerencie suas equipes, adicione novos pilotos ou encontre escuderias competitivas.',
        preview: 'Preview da Equipe',
        name: 'Nome da Equipe',
        tag: 'TAG',
        description: 'Descrição',
        logo: 'Logo da Equipe',
        discord_role: 'ID do Cargo no Discord',
        submit: 'Criar Equipe',
        tag_hint: '2 a 8 caracteres (A-Z, 0-9)',
        name_placeholder: 'Ex: Scuderia Ferrari',
        desc_placeholder: 'Fale um pouco sobre as origens e objetivos da sua equipe...',
        tag_placeholder: 'EX: FER',
        role_placeholder: 'ID do cargo para notificações automáticas',
        upload_logo: 'Fazer upload do logo',
        drivers: 'Pilotos',
        wins: 'Vitórias',
        about: 'Sobre a Equipe',
        no_description: 'Esta equipe ainda não possui uma descrição.',
        request_join: 'Solicitar Ingresso',
        leave: 'Sair da Equipe',
        invite_driver: 'Convidar Piloto',
        invite_message_default: 'Gostaríamos que você se juntasse à nossa equipe!',
        invite_success: 'Convite enviado com sucesso!',
        invite_error: 'Erro ao enviar convite. Piloto já pode estar na equipe ou convidado.',
        search_placeholder: 'Buscar por nome ou username...',
        no_pilots_found: 'Nenhum piloto encontrado.',
        member_badge: 'Membro da Equipe',
        leave_confirm: 'Tem certeza que deseja sair desta equipe?',
        leave_success: 'Você saiu da equipe.',
        leave_error: 'Erro ao sair da equipe.',
        team_settings: 'Configurações da Equipe'
      },
      leagues: {
        title: 'Ligas',
        subtitle: 'Explore as Ligas de e-motorsport, inscreva-se em campeonatos oficiais ou gerencie sua própria organização.',
        create: 'Criar Liga',
        create_title: 'Cadastrar Liga',
        step_1: 'Identidade',
        step_2: 'Configuração',
        step_3: 'Revisão',
        name_label: 'Nome da Liga',
        name_placeholder: 'Ex: Virtual Racing Association',
        slug_label: 'Slug da Liga (URL)',
        slug_hint: 'Gerado automaticamente para a URL da liga',
        logo_label: 'Logo da Liga',
        banner_label: 'Banner (1920x400)',
        privacy: 'Privacidade',
        privacy_public: 'Pública (Todos podem ver)',
        privacy_private: 'Privada (Apenas convidados)',
        desc_placeholder: 'Fale um pouco sobre as origens, os campeonatos e os objetivos da sua organização...',
        regulations: 'Regulamento',
        stewards_title: 'Painel de Stewards',
        stewards_hint: 'Assegure a integridade das corridas. Mínimo 1 steward.',
        stewards_error_min: 'Mínimo de 1 steward necessário.',
        stewards_error_odd: 'Recomenda-se número ímpar de stewards.',
        add_steward: 'Adicionar Steward',
        create_button: 'Criar Liga ✨',
        members: 'Membros',
        active_events: 'Eventos Ativos',
        subscription_section: 'Assinatura',
        no_subscription: 'Sem Assinatura (Grátis)',
        with_subscription: 'Com Assinatura (Premium)',
        subscription_hint: 'Ligas com assinatura permitem cobrança recorrente de membros.',
        subscription_future: 'Disponível em breve',
        access_code: 'Código de Acesso',
        access_code_hint: 'Opcional. Se definido, usuários precisarão deste código para entrar na liga.',
        review_subtitle: 'Revise antes de criar'
      },
      league_profile: {
        overview: 'Visão Geral',
        calendar: 'Calendário',
        standings: 'Classificação',
        teams: 'Equipes',
        stewards: 'Stewards',
        admin: 'Admin',
        next_events: 'Próximos Eventos',
        last_results: 'Últimos Resultados',
        top_pilots: 'Top Pilotos',
        quality_score: 'Quality Score',
        members: 'Seguidores',
        events_count: 'Eventos Realizados',
        trilho_1: 'Trilho 1 (Global)',
        trilho_2: 'Trilho 2 (Liga)',
        no_events: 'Nenhum evento programado.',
        auto_promoted: '📢 Divulgado automaticamente',
        create_event: 'Criar Evento',
        about: 'Sobre a Liga',
        no_description: 'Esta liga ainda não possui uma descrição.',
        no_events_yet: 'Nenhum evento futuro programado.',
        view_all_standings: 'Ver Classificação Completa',
        regulations: 'Regulamento',
        no_seasons_yet: 'Nenhuma temporada cadastrada.',
        not_found: 'Liga não encontrada',
        not_found_desc: 'A liga que você está procurando não existe ou foi removida.',
        browse_leagues: 'Explorar Ligas',
        no_standings: 'Nenhuma classificação disponível.',
        admin_panel: 'Painel Administrativo',
        admin_desc: 'Gerencie as configurações e membros da sua liga',
        restricted_access: 'Acesso Restrito ao Proprietário',
        follow: 'Seguir Liga',
        following: 'Seguindo'
      },
      ranking: {
        title: 'Ranking Global',
        subtitle: 'Acompanhe sua posição e o desempenho da comunidade e-MSS.',
        filter_game: 'Jogo',
        filter_category: 'Categoria',
        filter_tier: 'Carteira',
        table: {
          pos: 'Pos',
          pilot: 'Piloto',
          ers: 'eRS',
          license: 'Licença',
          class: 'Classe',
          driver_cat: 'Categoria de Piloto',
          rci: 'mRCI'
        },
        categories: {
          turismo: 'Turismo',
          formula: 'Fórmula',
          rally: 'Rally'
        }
      },
      events_creation: {
        title: 'Criar Evento',
        min_license: 'Licença Mínima',
        steps: {
          basic_info: 'Informações Básicas',
          stages_races: 'Etapas e Corridas',
          rules_details: 'Regras e Detalhes'
        },
        info_general: 'Informações Gerais',
        info_general_desc: 'Defina o nome, jogo e categoria do seu evento.',
        labels: {
          event_title: 'Nome do Evento',
          game: 'Jogo',
          category: 'Categoria',
          event_type: 'Tipo de Evento',
          platform: 'Plataforma',
          entry_fee: 'Taxa de Inscrição',
          entry_fee_desc: 'Defina o valor em e-Tokens',
          event_banner: 'Banner do Evento',
          day_label: 'Rótulo do Dia',
          day_datetime: 'Data e Hora do Dia',
          circuit_layout: 'Circuito / Traçado',
          allowed_car: 'Carro Permitido',
          race_mode: 'Modo de Corrida',
          laps_count: 'Nº de Voltas',
          duration_min: 'Duração (min)',
          weather: 'Clima',
          virtual_start: 'Início Virtual',
          quali_laps: 'Voltas Quali',
          race_notes: 'Observações da Corrida',
          race_image: 'Imagem da Corrida (Capa)',
          registration_requirements: 'Requisitos de Inscrição',
          check_admin_penalties: 'Verificar punições administrativas',
          check_admin_penalties_desc: 'Pilotos com punições pendentes na plataforma não poderão se inscrever.',
          require_minimum_license: 'Exigir carteira mínima',
          require_minimum_license_desc: 'Restringe a participação apenas para pilotos qualificados.',
          select_license: 'Selecione a Carteira',
          min_ers: 'eRS Mínimo',
          enable_splits: 'Habilitar Dinâmica de Splits',
          enable_splits_desc: 'Divide os inscritos em múltiplas sessões baseadas no eRS. A divisão oficial ocorrerá no momento em que você clicar em "Gerar Splits".',
          slots_per_split: 'Vagas por Split',
          slots_per_split_desc: 'Define o tamanho de cada bateria. Ex: Se houver 48 inscritos totais e 24 vagas por split, serão gerados 2 splits.',
          total_registration_limit: 'Limite Total de Inscrições',
          total_registration_limit_desc: 'Define o teto máximo de pilotos que podem se inscrever no evento como um todo.',
          regulations_details: 'Regulamento & Detalhes',
          official_regulations_link: 'Link do Regulamento Oficial (Opcional)',
          whatsapp_group_link: 'Link do Grupo de WhatsApp (Opcional)',
          car_classes: 'Classes de Carros',
          broadcast_link: 'Link da Transmissão (Opcional)',
          extra_details: 'Instruções ou Detalhes Extras',
          scoring_bonuses: 'Pontuação & Bônus',
          scoring_bonuses_desc: 'Configure pontos extras por performance e regras de pontuação customizadas.',
          points_pole: 'Pontos por Pole Position',
          points_fastest_lap: 'Pontos por Melhor Volta',
          custom_scoring_table: 'Tabela de Pontos Customizada (Corrida)',
          custom_scoring_table_desc: 'Insira os pontos separados por vírgula (Ex: 25, 18, 15, 12, 10...)',
          commission_penalties: 'Comissão & Punições',
          commission_penalties_desc: 'Configure os parâmetros de punições, pontuação por abandono e prazo de defesa para este evento.',
          identification: 'Identificação',
          stages_races_minimal: 'Etapas & Corridas',
          rules: 'Regras',
          event_status: 'Status do Evento',
          timezone: 'Fuso Horário (Referência do Organizador)',
          scoring_rule: 'Regra de Pontuação',
          custom_scoring_config: 'Configuração de Pontuação',
          race_positions_table: 'Tabela de Posições (Corrida)',
          qualy_positions_table: 'Tabela de Posições (Qualifying)',
          paid_event: 'Evento pago',
          timezone_brazil: 'Brasil (Brasília - UTC-3)',
          timezone_usa: 'USA (New York - UTC-5)',
          timezone_uk: 'UK (London - UTC+0)',
          timezone_france: 'France (Paris - UTC+1)',
          timezone_japan: 'Japan (Tokyo - UTC+9)',
          timezone_utc: 'UTC (Universal Coordinated Time)',
          scoring_custom: 'Personalizado (Manual)',
          scoring_ers: 'Padrão eRS (Plataforma)',
          scoring_f1: 'Formato F1 (25-18-15...)',
          scoring_gt: 'Formato GT',
          status_draft: 'Rascunho (Privado)',
          status_published: 'Publicado (Aberto)',
          status_finished: 'Finalizado',
          status_closed: 'Encerrado',
          game_pc: 'PC (Steam/Epic)',
          game_ps5: 'PlayStation 5',
          game_xbox: 'Xbox Series X/S',
          game_cross: 'Cross-platform',
          day_number: 'Dia {{number}}',
          race_number: 'Corrida {{number}}',
          upload: 'Upload',
          preview: 'Preview',
          start_date: 'Data e Hora de Início',
          entry_fee_label: 'Taxa de Inscrição',
          tokens: 'Tokens',
          weather_sunny: '☀️ Sol',
          weather_rainy: '🌧️ Chuva',
          weather_cloudy: '☁️ Nublado',
          weather_variable: '🌦️ Variável',
          private_league_warning: 'Liga privada — eRS não será gerado nas corridas deste evento.',
          back: 'Voltar',
          save_changes: 'Salvar Alterações',
          saving: 'Salvando...',
          loading_data: 'Carregando dados...',
          error_saving: 'Erro ao salvar evento',
          error_creating: 'Erro ao criar evento',
          edit_title: 'Editar Evento',
          settings_difficulty: 'Configurações e Dificuldade',
          difficulty_label_req: 'Dificuldade / Assistências (Obrigatório)',
          assist_all_allowed_perc: 'Assistências todas liberadas (80% eRS)',
          assist_partial_perc: 'Assistências parcialmente liberadas (90% eRS)',
          assist_blocked_perc: 'Assistências bloqueadas (100% eRS)',
          virtual_categories: 'Categorias Virtuais',
          enable_virtual_categories: 'Habilitar Categorias Virtuais (ex: PRO, AM)'
        },
        placeholders: {
          event_title: 'Ex: Mundial de GT3',
          select_game: 'Selecione o simulador...',
          select_category: 'Selecione a categoria...',
          banner_url: 'Cole o link ou use o botão de upload ao lado',
          day_label: 'Ex: Classificatórias',
          select_layout: 'Selecione o traçado...',
          select_car: 'Selecione o carro...',
          race_notes: 'Regras específicas, procedimentos, etc...',
          image_url_alt: 'Ou cole a URL aqui...',
          select_min_license: 'Escolha o nível mínimo...',
          min_ers: 'Ex: 1500 (0 = sem mínimo)',
          slots_per_split: 'Ex: 24 vagas por grid',
          total_registration_limit: 'Ex: 48 (0 = ilimitado)',
          car_classes: 'Ex: GT3, GTE, Protótipos',
          extra_details: 'Insira detalhes sobre briefing, pits obrigatórios, clima...',
          broadcast_url: 'https://youtube.com/live/...',
          scoring_table_desc: 'Insira os pontos separados por vírgula (Ex: 25, 18, 15, 12, 10...)',
          banner_drag_drop: 'Clique ou arraste para enviar o banner',
          banner_ideal_dim: 'Dimensão ideal: 1200 × 630 px (proporção 16:9)',
          banner_formats_limit: 'Outras dimensões são ajustadas automaticamente · JPG, PNG ou WebP · máx 5 MB',
          banner_whatsapp_hint: 'Imagens maiores que 300 KB são comprimidas automaticamente para funcionar na prévia do WhatsApp.',
          uploading_compressing: 'Enviando e comprimindo...',
          uploading: 'Enviando...',
          ideal_dim_race: '800 × 450 px'
        },
        actions: {
          add_race_to_day: 'Adicionar corrida ao Dia {{day}}',
          add_event_day: 'Adicionar novo dia de evento',
          next_stages: 'Etapas & Corridas',
          next_rules: 'Regras de Inscrição',
          previous: 'Anterior',
          upload_image: 'Upload de Imagem'
        },
        success: {
          banner_uploaded: 'Banner enviado com sucesso!',
          race_image_uploaded: 'Imagem enviada!',
          create: 'Evento criado com sucesso!',
          edit: 'Evento atualizado com sucesso!'
        },
        errors: {
          banner_upload: 'Erro ao enviar banner: ',
          race_image_upload: 'Erro ao enviar imagem: ',
          create: 'Erro ao criar evento.',
          edit: 'Erro ao atualizar evento.'
        },
        validation: {
          missing_fields: 'Falta preencher: {{fields}}',
          fill_required: 'Preencha os campos obrigatórios.',
          missing_race_details: 'Falta preencher: Pista, Carro e Voltas em TODAS as etapas/corridas configuradas.',
        },
        warnings: {
          private_league: 'Liga privada — eRS não será gerado nas corridas deste evento.',
          past_date: 'A data deve ser no futuro para eventos publicados. Use o status "Rascunho" para criar ou editar eventos com datas retroativas.',
        }
      },
      results_posting: {
        title: 'Lançamento de Resultados',
        session: 'Sessão',
        save_draft: 'Salvar Rascunho',
        publish: 'Publicar e Calcular eRS',
        irreversible: 'Esta ação é IRREVERSÍVEL. O eRS dos pilotos será recalculado globalmente.',
        pos: 'Pos.',
        pilot: 'Piloto',
        time: 'Tempo/Intervalo',
        penalty: 'Pen.',
        delta: 'eRS Delta',
        status_draft: 'Rascunho',
        status_final: 'Finalizado',
        confirm_title: 'Confirmar Publicação?',
        success_title: 'Resultados Publicados!'
      },
      incidents: {
        title: 'Enviar Ocorrência',
        subtitle: 'Relate incidentes de pista com precisão para análise dos Stewards.',
        type_collision: 'Colisão / Tocada',
        type_limits: 'Limite de Pista',
        type_conduct: 'Conduta Antidesportiva',
        type_rejoin: 'Retorno Perigoso',
        type_flags: 'Ignorar Bandeiras',
        type_other: 'Outros',
        session: 'Sessão / Corrida',
        lap: 'Volta do Incidente',
        reported_pilot: 'Piloto Reportado',
        description: 'Descrição Detalhada',
        description_hint: 'Descreva os fatos com clareza (mínimo 50 caracteres).',
        evidence: 'Link da Evidência (Qualquer Link / Vídeo)',
        submit: 'Enviar Ocorrência',
        success: 'Ocorrência enviada com sucesso! Aguarde o veredito dos stewards.',
        incident_type: 'Tipo de Incidente'
      },
      stewardship: {
        title: 'Painel de Stewards',
        pending: 'Ocorrências Pendentes',
        total: 'Total de Casos',
        urgent: 'Urgente',
        voted: 'Votado',
        votes: 'Votos',
        consensus: 'Consenso Atingido',
        penalize: 'Penalizar',
        dismiss: 'Arquivar',
        review: 'Em Revisão',
        points: 'Pontos',
        penalty_light: 'Leve',
        penalty_medium: 'Média',
        penalty_grave: 'Grave',
        penalty_gravissimo: 'Gravíssima',
        verdict: 'Veredito Final',
        stewards_count: '{{count}} Stewards Ativos',
        dashboard: 'Dashboard Global',
        my_assignments: 'Minhas Atribuições',
        global_analysis: 'Análise Global de Incidentes',
        track_incidents: 'Incidentes em Pista',
        administration: 'ADMINISTRAÇÃO',
        reported_by: 'Reportado por:',
        reported_pilot: 'Acusado:',
        video_evidence: 'Evidência em Vídeo',
        open_external_player: 'Abrir Player Externo',
        vote_tally: 'Contagem de Votos ({{current}}/{{total}})',
        your_vote: 'Seu Voto',
        severity_points: 'Gravidade e Pontos',
        pts: 'pts',
        confirm_vote: 'Confirmar Voto',
        case_closed: 'Caso Encerrado',
        verdict_consolidated: 'Veredito consolidado. Nenhuma nova votação é permitida.',
        no_incidents: 'Nenhuma ocorrência',
        fair_play: 'Os pilotos estão se comportando muito bem na pista hoje.',
        analytics: 'Análise',
        resolved: 'Resolvidos',
        consensus_avg: 'Consenso Médio',
        urgency: 'Urgência',
        cases: 'Casos',
        steward_team: 'Equipe de Comissários',
        system_active: 'SISTEMA ATIVO',
        lap_short: 'VOLTA',
        pilot_report: 'Relato do Piloto',
        digital_evidence: 'Evidência Digital',
        watch_replay: 'ASSISTIR REPLAY DO INCIDENTE',
        no_evidence: 'Nenhuma evidência visual anexada a este relatório.',
        assigned_stewards: 'Stewards Atribuídos',
        decision_panel: 'Painel de Decisão',
        quorum: 'QUÓRUM: {{current}} / {{total}}',
        justification_history: 'Histórico de Justificativas',
        panel_member: 'Membro do Painel',
        no_justification: 'Nenhuma justificativa fornecida.',
        severity_label: 'GRAVIDADE:',
        points_label: 'PONTOS:',
        justification_placeholder: 'Justifique seu veredito tecnicamente baseando-se nas regras da liga...',
        confirm_final_verdict: 'CONFIRMAR VEREDITO FINAL',
        observer_mode: 'MODO OBSERVADOR',
        observer_desc: 'Você tem acesso a este painel como organizador, mas a tratativa técnica é exclusiva dos stewards designados para o quórum deste evento.',
        final_verdict: 'VEREDITO FINAL',
        voted_successfully: 'Votado com Sucesso',
        vote_registered_desc: 'Sua contribuição foi registrada no sistema central de justiça da liga.',
        process_closed: 'Processo Encerrado',
        download_ris: 'BAIXAR RELATÓRIO RIS (PDF)',
        steward_panel: 'PAINEL DO COMISSÁRIO',
        subtitle: 'Analise evidências, registre seus votos técnicos e colabore para manter a integridade das competições.',
        analytics_title: 'ANÁLISE DE DESEMPENHO',
        avg_quorum: 'QUÓRUM MÉDIO',
        response_time: 'TEMPO DE RESPOSTA',
        filters: 'FILTROS RÁPIDOS',
        all: 'Todas',
        collision: 'Colisão',
        track_limits: 'Limite de Pista',
        conduct: 'Conduta',
        incident_report: 'RELATO DO INCIDENTE',
        judgment_panel: 'PAINEL DE JULGAMENTO',
        voting_progress: 'PROGRESSO DA VOTAÇÃO',
        finalize_points: 'CONSOLIDAR PONTOS E ENCERRAR',
        waiting_quorum: 'AGUARDANDO QUÓRUM ({{current}} / {{total}})',
        suggested_severity: 'GRAVIDADE SUGERIDA',
        penalty_points: 'PONTOS DE PENALIZAÇÃO',
        confirm_verdict: 'CONFIRMAR VEREDITO',
        case_closed_desc: 'O veredito final já foi consolidado e as penalidades foram aplicadas aos pilotos envolvidos.',
        view_report: 'VISUALIZAR RELATÓRIO OFICIAL',
        generating_pdf: 'GERANDO PDF...',
        generate_report: 'GERAR RELATÓRIO RIS',
        clean_track: 'PISTA LIMPA',
        no_pending: 'Não há incidentes pendentes atribuídos a você no momento.',
        error_loading_assignments: 'Falha ao carregar atribuições.',
        error_loading_details: 'Erro ao carregar detalhes do incidente.',
        error_registering_vote: 'Falha ao registrar voto.',
        confirm_consolidate_desc: 'Deseja realmente consolidar este veredito? Isso aplicará as penalidades e encerrará o caso.',
        error_consolidating: 'Falha ao consolidar incidente.',
        error_generating_report: 'Falha ao gerar relatório. Verifique os logs do servidor.',
        vote_registered: 'Voto registrado com sucesso!',
        vote_error: 'Falha ao registrar voto.',
        loading_assignments: 'CARREGANDO ATRIBUIÇÕES...',
        abstain: 'Abster'
      },
      event_details: {
        about: 'Sobre o Evento',
        schedule: 'Cronograma Completo',
        cars: 'Máquinas',
        no_cars: 'Nenhum carro listado.',
        no_schedule: 'Nenhuma etapa configurada ainda.',
        day: 'Dia',
        duration: 'Duração',
        laps: '{{count}} Voltas',
        car: 'Carro',
        organizer_panel: 'Painel Organizador',
        edit: 'Editar',
        delete: 'Excluir',
        delete_confirm: 'Tem certeza que deseja excluir este evento? Esta ação não pode ser desfeita.',
        delete_success: 'Evento excluído com sucesso.',
        min_ers: 'eRS Mínimo',
        min_license: 'Licença Mínima',
        status: 'Status',
        regulations: 'Regulamento Oficial',
        organizer_notes: 'Notas do Organizador',
        no_details: 'Nenhum detalhe adicional fornecido pelo organizador.',
        free: 'Livre',
        view_pilots: 'Ver Pilotos',
        pilot_list: 'Lista de Pilotos Inscritos',
        pilot_name: 'Nome do Piloto',
        no_pilots: 'Nenhum piloto inscrito ainda.',
        delete_title: 'Excluir Evento',
        view_results: 'Ver/Lançar Resultados',
        launch_results: 'Lançar Resultados',
        manage_teams: 'Gerenciar Equipes',
        manage_cars: 'Gerenciar Carros',
        manage_categories: 'Gerenciar Categorias',
        confirm_registration: 'Confirmar Inscrição',
        confirm_registration_subtitle: 'Escolha seu carro e categoria para participar',
        select_car: 'Selecione seu Carro',
        select_virtual_category: 'Selecione sua Categoria Virtual',
        difficulty_label: 'Dificuldade / Assistências',
        assist_all_allowed: 'Liberadas (eRS 80%)',
        assist_partial: 'Parciais (eRS 90%)',
        assist_blocked: 'Bloqueadas (eRS 100%)',
        stewards: 'Comissários',
        organization: 'Organização',
        add_steward_placeholder: 'Adicionar comissário...',
        no_stewards_found: 'Nenhum comissário encontrado.',
        no_stewards_assigned: 'Nenhum comissário designado para este evento.',
        send_announcement_title: 'Enviar Aviso aos Inscritos',
        send_announcement_desc: 'Escreva uma mensagem rápida e importante. Ela será disparada instantaneamente como notificação no painel de todos os pilotos inscritos neste evento.',
        send_announcement_placeholder: 'Ex: Briefing obrigatório às 20h! Sala de discord #briefing-sala-1...',
        send_announcement_char_count: '{{count}} / 140 caracteres',
        send_announcement_btn: 'Enviar Aviso',
        send_announcement_btn_sending: 'Enviando...',
        send_announcement_success: 'Aviso enviado aos inscritos com sucesso!',
        send_announcement_error: 'Por favor, digite uma mensagem para enviar o aviso.'
      },
      registration: {
        title: 'Inscrições',
        registered: 'Inscrito',
        register: 'Inscrever-se',
        unregister: 'Cancelar Inscrição',
        success: 'Inscrição confirmada! Boa sorte na pista.',
        unregister_success: 'Inscrição cancelada com sucesso.',
        unregister_title: 'Cancelar Inscrição',
        unregister_confirm: 'Tem certeza que deseja cancelar sua inscrição?',
        error: 'Erro ao realizar inscrição.',
        limit: '{{count}} / {{total}} Pilotos',
        unlimited: '{{count}} / ∞ Pilotos',
        critical: 'ÚLTIMAS VAGAS',
        full: 'LOTADO',
        open: 'ABERTO'
      },
      settings: {
        title: 'Configurações de Usuário',
        subtitle: 'Gerencie seu perfil e preferências globais',
        profile: 'Perfil',
        appearance: 'Aparência',
        appearance_title: 'Interface e Tema',
        appearance_subtitle: 'Escolha como deseja visualizar a plataforma',
        theme_label: 'Esquema de Cores',
        theme_desc: 'Atualmente no modo {{theme}}',
        theme_dark: 'Escuro',
        theme_light: 'Claro',
        midnight: 'Modo Noturno (Midnight)',
        daylight: 'Modo Diurno (Daylight)',
        language_title: 'Idioma da Interface',
        language_subtitle: 'Escolha o idioma padrão para o console',
        integrations: 'Integrações',
        integrations_title: 'Integrações Externas',
        integrations_subtitle: 'Vincule suas contas para sincronizar dados',
        notifications: 'Notificações',
        notifications_title: 'Centro de Notificações',
        notifications_subtitle: 'Controle como e quando ser alertado',
        bank_title: 'Dados Financeiros',
        agents_tab: 'Agentes',
        bank_subtitle: 'A edição de dados financeiros estará disponível em breve após validação de identidade.',
        avatar_label: 'Avatar de Piloto',
        avatar_hint: 'Sincronizado via Google ou Personalizado',
        personal_data: 'Dados Pessoais',
        notif_session: 'Início de Sessão',
        notif_session_desc: 'Alertas 15 minutos antes da bandeira verde',
        notif_incidents: 'Incidentes de Pista',
        notif_incidents_desc: 'Notificações de protestos e penalidades',
        notif_announcements: 'Anúncios da Liga',
        notif_announcements_desc: 'Mudanças no calendário e regulamentos',
        notif_chat: 'Chat de Equipe',
        notif_chat_desc: 'Mensagens diretas de seus companheiros',
        nickname: 'Nickname',
        nickname_placeholder: 'Ex: Ayrton Senna',
        bio: 'Bio',
        location: 'Localização',
        save_changes: 'Salvar Alterações',
        success: 'Salvo com sucesso!',
        save_error: 'Erro ao salvar. Tente novamente.',
        slug_hint: 'Seu @slug será atualizado automaticamente com base no seu Nickname.',
        select_placeholder: 'Selecione...',
        saving: 'Salvando...',
        google_linked: 'Google Vinculado (Obrigatório)',
        discord: 'Discord',
        steam: 'Steam',
        bank_holder: 'Titular da Conta',
        bank_name: 'Banco',
        bank_pix: 'Chave PIX',
        language_label: 'Idioma da Interface',
        language_desc: 'Escolha o idioma padrão para o console',
        regional_language: 'Regional e Idioma',
        priority_game: 'Game Prioritário',
        priority_game_desc: 'Este game será carregado por padrão ao iniciar o console.',
        select_game: 'Selecione um game',
        privacy: 'Privacidade e Dados',
        privacy_title: 'Gestão de Privacidade',
        privacy_subtitle: 'Controle seus dados e visibilidade na plataforma',
        select_country: 'Selecione seu país...'
      },
      onboarding: {
        title: 'Bem-vindo ao e-MSS',
        subtitle: 'Para começar sua carreira, precisamos de algumas informações básicas.',
        nationality: 'Nacionalidade',
        priority_game: 'Qual seu game principal?',
        start_career: 'Começar minha Carreira',
        nickname: 'Seu Nickname na Plataforma',
        nickname_placeholder: 'Ex: Ayrton Senna',
        nickname_hint: 'Este é o nome exibido nos resultados, rankings e ligas. Use o mesmo apelido que você utiliza nos games para facilitar sua identificação pelos organizadores.',
        nickname_already_correct: 'Meu nickname já está correto — continuar'
      },
      manager: {
        title: 'Manager',
        subtitle: 'Gestão centralizada da plataforma e-Motorsport Series. Controle total de usuários, ativos e regras.',
        stats: {
          users: 'Usuários',
          leagues: 'Ligas',
          events: 'Eventos',
          teams: 'Equipes',
          sessions: 'Sessões'
        },
        tabs: {
          dashboard: 'Métricas',
          users: 'Usuários',
          tracks: 'Pistas',
          cars: 'Carros',
          events: 'Eventos',
          leagues: 'Ligas',
          rules: 'Regras',
          commission: 'Comissão',
          sandbox: 'Sandbox',
          schedule: 'Agenda'
        },
        events: {
          title: 'Gestão de Eventos',
          active: 'Ativos'
        },
        leagues: {
          title: 'Saúde das Ligas',
          active: 'Ativas'
        },
        rules: {
          title: 'Gestão de Rules',
          subtitle: 'Controle de Acesso Admin',
          revoke: 'Revogar',
          assign: 'Atribuir',
          loading: 'Carregando permissões...'
        },
        dashboard: {
          growth: 'Crescimento da Plataforma',
          alerts: 'Alertas do Sistema',
          placeholder_chart: 'Gráfico de usuários e sessões (Placeholder)'
        },
        users: {
          title: 'Gerenciar Pilotos',
          search_placeholder: 'Buscar por nome, @username ou e-mail...'
        },
        commission: {
          title: 'Parametrização da Comissão',
          subtitle: 'Gestão de Scoring e Punições',
          search_event: 'Buscar evento...',
          select_event: 'Selecione um Evento',
          save_success: 'Parâmetros de comissão salvos com sucesso!',
          save_error: 'Erro ao salvar parâmetros de comissão.',
          warning: 'Estas configurações afetam diretamente a pontuação bruta da sessão e o fluxograma de comissão da liga. Alterações durante um evento em andamento podem gerar inconsistências nos dados históricos.',
          penalty_ranges: 'Range de Pontos por Gravidade',
          light: 'Leve',
          medium: 'Médio',
          grave: 'Grave',
          gravissimo: 'Gravíssimo',
          dnf_points_title: 'Pontuação DNF (Abandono)',
          dnf_points_desc: 'Defina a regra de pontuação para pilotos que não completarem a prova',
          dnf_enabled: 'Pontuação Normal',
          dnf_enabled_desc: 'O piloto recebe pontos proporcionais à sua posição final, mesmo se abandonar.',
          dnf_fixed: 'Valor Fixo / Nerfado',
          dnf_fixed_desc: 'A pontuação é limitada a um valor fixo definido por você para qualquer DNF.',
          deadline_safety: 'Prazo para Defesa',
          deadline_desc: 'Determine quanto tempo o piloto tem para contestar punições',
          deadline_days: 'Total em dias',
          report_deadline_title: 'Prazo para Reporte',
          report_deadline_desc: 'Tempo máximo após a corrida para enviar denúncias de incidentes',
          scoring_tabs: {
            penalties: 'Punições',
            results: 'Pontuação',
            deadlines: 'Prazos'
          },
          errors: {
            invalid_range: 'O valor mínimo do range não pode ser maior que o máximo.'
          }
        },
        schedule: {
          title: 'Agenda Semanal',
          tab: 'Agenda',
          filter_game: 'Filtrar por Jogo',
          all_games: 'Todos os Jogos',
          week_label: '{{start}} – {{end}} · {{year}}',
          prev_week: 'Semana Anterior',
          next_week: 'Próxima Semana',
          current_week: 'Semana Atual',
          no_races: 'Sem corridas',
          send_discord: 'Enviar para Discord',
          sending: 'Enviando...',
          discord_success: 'Agenda enviada ao Discord com sucesso!',
          discord_error: 'Erro ao enviar agenda ao Discord.',
          preview_title: 'Preview — Agenda Semanal',
          events_count_one: '{{count}} evento',
          events_count_other: '{{count}} eventos'
        }
      },
      privacy_modal: {
        title: 'Atualização de Privacidade',
        description: 'Para continuarmos garantindo a segurança dos seus dados e a conformidade com a LGPD, precisamos que você revise e aceite nossa Política de Privacidade.',
        read_button: 'Ler Política de Privacidade',
        checkbox_label: 'Li e concordo com os termos',
        checkbox_hint: 'Ao prosseguir, você autoriza o e-MSS a processar seus dados essenciais para manutenção do perfil esportivo, histórico de corridas e integrações necessárias, conforme descrito no documento.',
        accept_button: 'Aceitar e Continuar',
        saving: 'Salvando...',
        success: 'Política de Privacidade aceita com sucesso.',
        error: 'Erro ao salvar suas preferências.',
        error_required: 'Você precisa aceitar a Política de Privacidade para continuar.',
        footer_note: 'Protocolo de Privacidade e-MSS • V{{version}}'
      },
      promotion_modal: {
        congratulations: 'PARABÉNS, PILOTO!',
        title: 'PROMOÇÃO DE CARTEIRA',
        subtitle: '{{name}}, você subiu de nível na plataforma.',
        demotion_header: 'ATUALIZAÇÃO DE CARTEIRA',
        demotion_title: 'REBAIXAMENTO DE CARTEIRA',
        demotion_subtitle: '{{name}}, sua carteira na plataforma foi ajustada.',
        from: 'DE',
        to: 'PARA',
        description: 'Sua consistência e comprometimento foram reconhecidos. A Carteira {{tier}} abre novas oportunidades e eventos de alto nível para você.',
        demotion_description: 'Sua carteira de piloto foi reajustada para Carteira {{tier}}. Continue competindo para evoluir novamente.',
        cta: 'Celebrar e Continuar',
        aria_label: 'Modal de Mudança de Carteira'
      },
      results: {
        validation: {
          pos_invalid: 'Posição inválida para o piloto {{name}}. Deve estar entre 1 e 99.',
          best_lap_invalid: 'Formato de melhor volta inválido para o piloto {{name}}. Use MM:SS,000.',
          laps_invalid: 'Voltas completadas inválida para o piloto {{name}}. Deve ser um número inteiro não negativo.',
          total_time_invalid: 'Formato de tempo total inválido para o piloto {{name}}. Use MM:SS,000.',
        },
        placeholder_pilot: 'Piloto',
        day_label: 'Dia {{day}}',
        search_placeholder: 'Digite o nome ou username do piloto...',
        no_pilot_found: 'Nenhum piloto encontrado.',
        add_pilot_btn: 'Adicionar Piloto à Grade',
        empty_grid_title: 'Grade vazia',
        empty_grid_desc: 'Adicione os pilotos usando o botão acima ou buscando por nome/username',
        table: {
          pos: 'POS.',
          pilot: 'PILOTO',
          best_lap: 'MELHOR VOLTA',
          total_time: 'TEMPO TOTAL',
          distance: 'DISTÂNCIA',
          laps: 'VOLTAS',
          status: 'STATUS'
        },
        legend: {
          title: 'STATUS DE PRESENÇA',
          registered: 'O piloto participou e completou a prova normalmente.',
          dns: 'O piloto estava inscrito, mas não largou (não participou da prova).',
          dnf: 'O piloto largou a corrida, mas não completou a prova (abandono ou quebra).',

          dsq: 'O piloto foi desclassificado por alguma infração técnica ou desportiva.'
        }
      },
      history_page: {
        subtitle: 'Histórico completo de desempenho',
        pos_history: 'Histórico de Posições',
        ers_performance: 'Aproveitamento eRS',
        insufficient_data: 'Dados insuficientes',
        all_races: 'Todas as Corridas',
        results: 'Resultados',
        results_count: '{{count}} Resultados',
        table: {
          date: 'Data',
          event: 'Evento',
          pos: 'Pos',
          sof: 'SoF',
          ers: 'eRS',
          no_races: 'Nenhuma corrida registrada no histórico.',
        },
        },
        league_admin: {
          panel_title: 'ADMINISTRAÇÃO',
          panel_subtitle: 'Gestão completa da sua liga.',
          general_settings: 'CONFIGURAÇÕES',
          general_settings_desc: 'Edite o nome, descrição, logos e regras.',
          edit_league: 'EDITAR LIGA',
          co_organizers: 'STAFF E ADMINS',
          co_organizers_desc: 'Adicione ou remova permissões de organização.',
          remove_co_organizer: 'Remover permissão',
          search_users: 'Buscar piloto...',
          danger_zone: 'ÁREA CRÍTICA',
          danger_zone_desc: 'Ações irreversíveis como excluir a liga.',
          delete_league: 'EXCLUIR LIGA'
        },
        agents: {
          title: 'AGENTES',
          subtitle: 'Instale o agente no seu PC para enviar telemetria automática às corridas.',
          pairing_title: 'PAREAMENTO',
          pairing_desc: 'Gere um código e digite-o no agente (ícone da bandeja → Parear). O código expira em 15 minutos.',
          generate: 'GERAR CÓDIGO',
          regenerate: 'GERAR NOVO CÓDIGO',
          code_label: 'CÓDIGO DE PAREAMENTO',
          expires_in: 'Expira em',
          copy: 'COPIAR',
          copied: 'Copiado!',
          devices_title: 'DISPOSITIVOS PAREADOS',
          devices_empty: 'Nenhum dispositivo pareado ainda.',
          last_seen: 'Último envio',
          never: 'Nunca',
          active: 'Ativo',
          inactive: 'Inativo',
          revoke: 'REVOGAR',
          delete: 'EXCLUIR',
          revoke_confirm_used: 'Revogar "{{name}}"? O dispositivo para de enviar telemetria (histórico mantido).',
          revoke_confirm_unused: 'Excluir "{{name}}"? Este pareamento nunca enviou dados e será removido definitivamente.',
          revoked: 'Dispositivo revogado.',
          download_title: 'DOWNLOAD',
          download_desc: 'Agente leve em segundo plano para o PC de sim. Suporta Forza Motorsport e AMS 2 / PCars2 (UDP).',
          download: 'BAIXAR AGENTE (Windows)',
          download_android_title: 'ANDROID',
          download_android_desc: 'APK para o celular na mesma rede do simulador. Ao instalar, autorize "fontes desconhecidas" e pareie pelo código.',
          download_android: 'BAIXAR AGENTE (Android)',
          steps_title: 'COMO FUNCIONA',
          step_1: '1. Baixe e instale o agente no seu PC de sim.',
          step_2: '2. Gere um código aqui e digite-o no agente para parear.',
          step_3: '3. Corra como sempre — a telemetria é enviada automaticamente.',
          step_4: '4. As sessões aparecem nas etapas e no seu histórico.'
        },
        telemetry: {
          title: 'TELEMETRIA',
          no_sessions: 'Nenhuma sessão enviada ainda',
          empty: 'Esta sessão não tem amostras suficientes para analisar.',
          load_error: 'Erro ao carregar a sessão.',
          laps: 'VOLTAS',
          lap: 'Volta',
          time: 'Tempo',
          ref_short: 'Ref',
          partial: 'parcial',
          full_lap: 'Volta inteira',
          map: 'MAPA',
          map_hint: 'Roda do mouse = zoom · arrastar = mover · duplo clique = reset',
          map_modes: { lines: 'Linhas das voltas', dlt: 'Ganho/perda (Δ)' },
          channels_title: 'CANAIS',
          charts_hint: 'Roda = zoom · arrastar = mover · duplo clique = reset · mouse = sincroniza',
          follow_car: 'Seguir carro',
          play: 'Play',
          pause: 'Pausar',
          space_hint: 'espaço = play/pause',
          invalid: 'inválida',
          ideal_lap: 'Volta ideal (melhores setores)',
          comparative: 'COMPARATIVO',
          baseline: 'Linha de base do Δ',
          baseline_opt: 'OPT',
          baseline_best: 'Melhor',
          baseline_pace: 'Pace',
          baseline_short: 'BASE',
          opt: 'OPT',
          opt_full: 'Volta ótima (costura dos melhores setores)',
          pace: 'Pace',
          pace_full: 'Pace (média por setor)',
          best_full: 'Melhor volta da sessão',
          history: 'HISTÓRICO DE VOLTAS',
          no_sectors: 'Esta sessão não tem dados de setores por volta (lotes antigos do agente).',
          summary: 'RESUMO DAS VOLTAS SELECIONADAS',
          sum: {
            vmax: 'V máx',
            vmin: 'V mín',
            vavg: 'V méd',
            thr: 'Acel. total',
            brk: 'Freio',
            coast: 'S-pedal (coast)',
          },
          compare: 'Comparar com…',
          compare_title: 'COMPARAR COM OUTRO PILOTO',
          compare_hint: 'Sessões enviadas por outros pilotos na mesma pista. Escolha carregar a OPT (costura de melhores setores) ou a melhor volta deles.',
          compare_load: 'Carregando sessões…',
          compare_empty: 'Nenhuma sessão de outro piloto nesta pista.',
          compare_active: 'Comparando com',
          compare_remove: 'Remover',
          compare_load_error: 'Não foi possível carregar — sessão sem volta válida ou sem setores.',
          compare_not_comparable: 'Comparação indisponível — pista, carro ou evento diferentes.',
          compare_search: 'Buscar por gamertag ou nome…',
          compare_max_pilots: 'Máximo de 3 pilotos na comparação — remova um para incluir outro.',
          compare_in_comparison: 'na comparação',
          compare_pro_lock: 'Comparar com outro piloto é um recurso do plano Piloto PRO',
          compare_pro_title: 'COMPARAÇÃO É RECURSO PRO',
          compare_pro_hint: 'A comparação entre pilotos (carro + pista + tipo de sessão) é exclusiva do plano Piloto PRO. Suas sessões e voltas continuam disponíveis gratuitamente.',
          compare_pro_cta: 'Assinar Piloto PRO',
          active_lines: 'LINHAS ATIVAS',
          hide_line: 'Ocultar/mostrar esta linha',
          remove_line: 'Remover da comparação',
          samples: 'amostras',
          channels: {
            delta: 'Delta (s)',
            spd: 'Velocidade (km/h)',
            pedals: 'Pedais (▲ acel · ▼ freio)',
            thr: 'Acelerador (%)',
            brk: 'Freio (%)',
            gear: 'Marcha',
            rpm: 'RPM',
          }
        }
      }
    },
  'es': {
    translation: {
      common: {
        login: 'Iniciar Sesión',
        logout: 'Salir',
        entrar: 'Entrar en Pista',
        ranking: 'Ver Ranking',
        back: 'Volver',
        previous: 'Anterior',
        next: 'Siguiente',
        next_step: 'Próximo Paso',
        loading: 'Cargando...',
        saving: 'Guardando...',
        save_changes: 'Guardar Cambios',
        create_event: 'Crear Evento',
        read_more: 'Leer más',
        view_details: 'Ver detalles',
        independent: 'Independiente',
        independent_league: 'Liga Independiente',
        coming_soon: 'Próximamente',
        privacy: 'Privacidad',
        maintenance: 'En Mantenimiento',
        close: 'Cerrar',
        cancel: 'Cancelar',
        hours: 'Horas',
        days: 'Días',
        day: 'Día',
        race: 'Carrera',
        laps: 'Vueltas',
        time: 'Tiempo',
        upload: 'Subir',
        upload_image: 'Subir Imagen',
        free: 'Gratis',
        paid_tokens: 'Pago (e-Tokens)',
        value: 'Valor',
        cross_platform: 'Cross-platform',
        success: 'Éxito',
        error: 'Error',
        fill_all_fields: 'Por favor, rellene todos los campos.'
      },
      marbles: {
        title: 'Saldo de Marbles',
        wallet_button: 'Cartera de Marbles',
        loading: 'Cargando...',
        error: 'Error al cargar el saldo',
        error_history: 'Error al cargar el extracto',
        retry: 'Reintentar',
        empty: 'Aún no hay movimientos',
        history_title: 'Extracto',
        view_full: 'Ver extracto completo',
        private_note: 'Solo tú puedes ver este saldo',
        settings_tab: 'Cartera',
        settings_title: 'Cartera de Marbles',
        settings_subtitle: 'Tu saldo y todos los movimientos de tu cuenta',
        tx: {
          deposit: 'Depósito',
          admin_grant: 'Crédito de la plataforma',
          event_entry_fee: 'Tarifa de inscripción',
          refund: 'Reembolso',
          event_prize: 'Premio del evento',
          platform_prize: 'Premio de la plataforma',
          ecommerce_purchase: 'Compra en el marketplace',
          withdrawal_hold: 'Retiro en proceso',
          withdrawal_cancelled: 'Retiro cancelado',
          admin_deduction: 'Ajuste de la plataforma'
        }
      },
      pages: {
        landing: {
          upcomingEvents: 'Próximos Campeonatos',
          viewAllLeagues: 'Ver Todas las Ligas',
          registeredPilots: 'Pilotos Registrados',
          completedRaces: 'Carreras Realizadas',
          enterPlatform: 'Entrar en la Plataforma'
        },
        dashboard: {
          overview: 'Visión General',
          myRegistrations: 'Mis Inscripciones',
          tokenBalance: 'Saldo de e-Tokens',
          seasonStats: 'Estadísticas de la Temporada',
          nextRace: 'Próxima Carrera'
        },
        league: {
          about: 'Sobre la Liga',
          activeSeasons: 'Campeonatos Activos',
          followers: 'Seguidores',
          follow: 'Seguir Liga',
          regulations: 'Reglamento Interno',
          organizedBy: 'Organizado por'
        },
        event: {
          openRegistrations: 'Inscripciones Abiertas',
          grid: 'Parrilla de Salida',
          briefing: 'Briefing de Carrera',
          allowedCars: 'Coches Permitidos',
          slotsRemaining: 'Plazas Restantes',
          register: 'Inscribirse'
        },
        results: {
          saveResults: 'Guardar Resultados',
          publishStandings: 'Publicar Clasificación',
          penalties: 'Sanciones Aplicadas',
          fastestLap: 'Vuelta Rápida',
          disqualified: 'Descalificado (DSQ)',
          uploadTelemetry: 'Cargar Telemetría'
        }
      },
      pwa: {
        install_ios: "Toque Compartir y 'Añadir a la pantalla de inicio' para una experiencia nativa.",
        install_android: "Instale e-MSS en su pantalla de inicio para acceso rápido.",
        install_button: "Instalar App",
        ios_alert: "Para instalar en iOS: toque el botón Compartir en la barra inferior de Safari y seleccione 'Añadir a la pantalla de inicio'."
      },
      privacy_modal: {
        title: 'Actualización de Privacidad',
        description: 'Para seguir garantizando la seguridad de sus datos y el cumplimiento de la normativa de protección de dados (LGPD), necesitamos que revise y acepte nuestra Política de Privacidad.',
        read_button: 'Leer Política de Privacidad',
        checkbox_label: 'He leído y acepto los términos',
        checkbox_hint: 'Al continuar, autoriza a e-MSS a procesar sus datos esenciales para el mantenimiento de su perfil deportivo, historial de carreras e integraciones necesarias, tal como se describe en el documento.',
        accept_button: 'Aceptar y Continuar',
        saving: 'Guardando...',
        success: 'Política de Privacidad aceptada con éxito.',
        error: 'Error al guardar sus preferencias.',
        error_required: 'Debe aceptar la Política de Privacidad para continuar.',
        footer_note: 'Protocolo de Privacidad e-MSS • V{{version}}'
      },
      promotion_modal: {
        congratulations: '¡FELICIDADES, PILOTO!',
        title: 'PROMOCIÓN DE CARTERA',
        subtitle: '{{name}}, has subido de nivel en la plataforma.',
        demotion_header: 'ACTUALIZACIÓN DE CARTERA',
        demotion_title: 'AJUSTE DE CARTERA',
        demotion_subtitle: '{{name}}, tu cartera en la plataforma ha sido ajustada.',
        from: 'DE',
        to: 'A',
        description: 'Tu consistencia y compromiso han sido reconocidos. La Cartera {{tier}} abre nuevas oportunidades y eventos de alto nivel para ti.',
        demotion_description: 'Tu cartera de piloto se ha reajustado a Cartera {{tier}}. Sigue compitiendo para evolucionar de nuevo.',
        cta: 'Celebrar y Continuar',
        aria_label: 'Modal de Cambio de Cartera'
      },
      maintenance: {
        pill: 'PIT STOP',
        eyebrow: 'Mantenimiento programado',
        title_top: 'EN',
        title_bottom: 'MANTENIMIENTO',
        lead: 'La plataforma está pasando por una intervención técnica para llevar el e-MSS al siguiente nivel de rendimiento. Tu piloto, tu rating y todo tu historial siguen intactos: volvemos en instantes.',
        status_value: 'Sistema fuera de línea',
        clock_label: 'Reloj del paddock',
        cta_secondary: 'Hablar con el equipo',
        note_title: 'Gracias por la paciencia',
        note_body: 'Los resultados ya publicados, los ratings y las Carteras Safety no se han visto afectados. Dudas y reportes siguen atendiéndose en nuestro Discord.',
        support: 'emsseries@gmail.com',
        footer_brand: 'e-Motorsport Series',
        footer_legal: 'Plataforma de Automovilismo Virtual'
      },
      landing: {
        hero: {
          season: 'PLATAFORMA GLOBAL DE AUTOMOVILISMO VIRTUAL',
          title: 'TU CARRERA EN SIMRACING EN UN SOLO LUGAR',
          subtitle: 'Construye tu rating eRS, conquista licencias digitales y unifica tu historial competitivo. Donde quiera que corras, tus resultados cuentan.',
          sim_racing: 'Consola Sim Racing',
          fh6: 'Consola Forza Horizon 6'
        },
        problem: {
          title: 'Correr sin historial es dar vueltas en círculos',
          items: [
            'Carreras dispersas en grupos de WhatsApp',
            'Resultados perdidos en planillas antiguas',
            'Incidentes resueltos en discusiones sin transparencia',
            'Ningún registro oficial para demostrar tu verdadero nivel'
          ],
          closing: 'Tu talento merece un registro oficial. El estándar EMSS pone al piloto en el centro.'
        },
        stats: {
          pilots: 'Pilotos registrados',
          events: 'Eventos activos',
          orgs: 'Ligas funcionando'
        },
        sections: {
          events: 'Eventos abiertos',
          ranking: 'Ranking Global',
          wallets: 'Carteras Digitales',
          orgs: 'Ligas Asociadas'
        },
        feed: {
          title: 'COMPETICIONES EN VIVO',
          explore: 'Explorar eventos',
          drivers: 'pilotos',
          slots: 'plazas',
          final_phase: 'fase final'
        },
        value: {
          title: 'Cuando el piloto evoluciona, el automovilismo virtual crece',
          text: 'Con el eRS y la Cartera Safety, cada curva suma puntos a tu carrera.\n\nPilotos motivados corren con más frecuencia, respetan la pista y buscan ligas estructuradas.\n\nEs el piloto quien decide dónde quiere acelerar.',
          points: [
            'Rating eRS que se actualiza en cada carrera',
            'Historial de carrera unificado y eterno',
            'Stewarding profesional y Cartera Safety',
            'Grilla nivelada por rendimiento real'
          ]
        },
        trust: {
          title: 'Ligas que ya están evolucionando con el estándar EMSS'
        },
        pilot_path: {
          title: 'Cada vuelta construye tu legado',
          subtitle: 'Tu carrera en e-Motorsport ahora tiene un registro oficial. Del karting al prototipo, tu historial te acompaña.',
          items: [
            {
              title: 'Licencia Digital e-MSS',
              text: 'Tu cartera evoluciona según tu seguridad y velocidad en las pistas de la plataforma.'
            },
            {
              title: 'Rating Global eRS',
              text: 'El Electronic Rating System garantiza grillas equilibradas contra pilotos de tu nivel.'
            },
            {
              title: 'Historial Eterno de Carrera',
              text: 'Accede a resultados de años atrás en segundos. Tu historia queda grabada para siempre.'
            }
          ]
        },
        segment: {
          organizer: {
            title: 'Para Organizadores de Liga',
            text: 'Cuando tus pilotos exijan una estructura profesional, la plataforma EMSS entrega automatización total y stewarding.'
          },
          pilot: {
            title: 'Para Pilotos',
            text: 'Construye tu reputación, sigue tu evolución en tiempo real y disputa posiciones en el ranking global.'
          },
          sponsor: {
            title: 'Para Patrocinadores y Marcas',
            text: 'Conecta tu empresa al público apasionado por la velocidad y la tecnología con visibilidad real.',
            benefits: [
              'Exposición de marca en transmisiones en vivo, overlays y lobbies oficiales',
              'Acceso a datos de participación de la comunidad activa de SimRacing',
              'Naming rights de campeonatos, e-Tokens y trofeos oficiales de la plataforma',
              'Métricas transparentes de alcance y participación de la audiencia'
            ]
          }
        },
        cta: {
          title: 'Tu carrera en el e-Motorsport comienza hoy',
          button: 'Crear mi perfil de piloto ahora'
        }
      },
      login: {
        title: 'ENTRAR EN PISTA',
        subtitle: 'Accede con tu cuenta de Google para comenzar tu carrera virtual',
        google: 'Continuar con Google',
        terms: 'Al entrar, aceptas los Términos de Uso'
      },
      console: {
        dashboard: 'Panel',
        events: 'Eventos',
        results: 'Resultados',
        ranking: 'Ranking',
        garage: 'Garaje',
        settings: 'Ajustes',
        stewardship: 'Comisión',
        help: 'Ayuda',
        online: 'Pilotos Online',
        rating: 'Tu eRS',
        track: 'Ir a la Pista',
        support: 'Soporte',
        logout: 'Cerrar Sesión',
        back_to_site: 'Volver al Sitio',
        search: 'Buscar eventos...',
        category: 'Categoría',
        license: 'Licencia',
        game: 'Juego',
        reset: 'Restablecer Filtros',
        overview: 'Visión General',
        welcome: 'Bienvenido de nuevo',
        next_event: 'PRÓXIMO EVENTO',
        all: 'TODOS',
        practice: 'PRÁCTICA',
        qualifying: 'CLASIFICACIÓN',
        race: 'CARRERA',
        my_leagues: 'MIS LIGAS',
        no_leagues_followed: 'Aún no sigues ninguna liga. Explora las ligas para recibir actualizaciones.',
        game_selector_disabled: 'Selector no disponible en esta pantalla',
        cycle: {
          week: 'Semana',
          tooltip: '{{label}} — Semana {{week}} de {{total}}',
        },
        notifications: {
          title: 'Notificaciones',
          mark_all_read: 'Marcar todas como leídas',
          no_notifications: 'No hay notificaciones nuevas',
          view_all: 'Ver todas',
          incident_reported: 'Incidente Reportado',
          verdict_published: 'Veredicto Publicado',
          steward_assignment: 'Nueva Asignación',
          new_league: 'Nueva Liga Creada',
          new_event: 'Nuevo Evento Creado',
          new_user: 'Nuevo Piloto Registrado'
        }
      },
      pilot_console: {
        safety_ers: 'eRS',
        driver_rank: 'Rank del Piloto',
        recommended: 'RECOMENDADO',
        confirmed: 'CONFIRMADO',
        registrations_open: 'INSCRIPCIONES ABIERTAS',
        enter_server: 'Entrar al Servidor',
        no_highlight: 'Ningún evento destacado',
        time_to_green: 'Tiempo hasta la Bandera Verde',
        waiting_next: 'Esperando Próximo Evento',
        days: 'DÍAS',
        hours: 'HRS',
        minutes: 'MIN',
        seconds: 'SEG',
        races_completed: 'Carreras Realizadas',
        podiums: 'Podios',
        avg_finish: 'Media Pos.',
        full_telemetry: 'Análisis de Telemetría Completa',
        my_roster: 'Mis Ligas',
        my_calendar: 'Mi Calendario',
        syncing: 'Sincronizando...',
        no_active_registrations: 'Ninguna inscripción activa',
        upcoming_races: 'Próximas Carreras',
        followed_leagues_races: 'LIGAS QUE SIGUES',
        community: 'COMUNIDAD',
        no_races_available: 'No hay otras carreras disponibles en este momento',
        quick_links: 'Enlaces Rápidos',
        discord_community: 'Comunidad Discord',
        race_regulations: 'Reglamento de Carrera',
        pending_defenses: 'Defensas Pendientes',
        pending_defenses_desc: 'Protestas que te involucran y requieren tu atención o defensa dentro del plazo.',
        no_pending_defenses: '¡Excelente! No tienes defensas pendientes.',
        present_defense: 'Presentar Defensa',
        defense_deadline_ended: 'Plazo terminado',
        defense_alert_title: 'Atención: tienes una acusación pendiente de defensa',
        defense_alert_desc: 'Se abrió una ocurrencia en tu contra y aún aguarda tu manifestación. Presenta tu defensa dentro del plazo para que la comisión analice el caso escuchando también tu versión.',
        defense_time_remaining: 'quedan {{hours}}h {{minutes}}min',
        defense_deadline_label: 'PLAZO PARA DEFENSA',
        defense_deadline_warning: 'El plazo técnico para enviar la defensa terminó el {{date}}. El formulario sigue disponible: aún puedes registrar tu versión de los hechos, pero la comisión evaluará un envío fuera de plazo.',
        defense_deadline_warning_generic: 'El plazo técnico para enviar la defensa ya terminó. El formulario sigue disponible: aún puedes registrar tu versión de los hechos, pero la comisión evaluará un envío fuera de plazo.',
        series_standings: 'Clasificación de Series',
        built_for_speed: 'Hecho para la Velocidad.',
        date: 'Fecha',
        circuit: 'Circuito',
        enter_race: 'Entrar en Carrera',
        hot_topic: 'En Destacado',
        driver_dashboard: 'PANEL DEL PILOTO',
        race_started: 'CARRERA EN CURSO',
        race_in_progress: 'CARRERA EN CURSO',
        starts_in: 'COMIENZA EN',
        next_race: 'PRÓXIMA CARRERA',
        view_details: 'Ver Detalles',
        race_title: 'Título de la Carrera',
        event: 'Evento',
        no_featured_event: 'Ningún evento destacado',
        cars: 'Coches',
        tracks: 'Pistas',
        cat: 'Cat.',
        dur: 'Dur.',
        lic: 'Lic.'
      },
      profile: {
        title: 'Perfil del Piloto',
        career: 'Carrera',
        stats: 'Estadísticas',
        integrations: 'Integraciones',
        avgPos: 'Posición Promedio',
        sessions: 'Sesiones',
        wins: 'Victorias',
        podiums: 'Podios',
        total: 'TOTAL',
        win_rate: 'TASA DE VICTORIA',
        podium_rate: 'TASA DE PODIO',
        rank_label: 'RANKING',
        points_suffix: 'PTS',

        unlink: 'Desvincular',
        link: 'Vincular',
        unlink_confirm: '¿Estás seguro de que deseas desvincular tu Discord?',
        discord_success: '¡Discord vinculado con éxito!',
        accountDeactivated: 'Cuenta inactivada con éxito.',
        deactivateError: 'Error al inactivar la cuenta.',
        accountDeleted: 'Cuenta eliminada permanentemente.',
        deleteError: 'Error al eliminar la cuenta.',
        no_races_found: 'Ninguna carrera registrada.',
        history: 'Historial de Carreras',
        license_history: 'Historial de Licencias',
        rate: 'Tasa',
        become_request_hint: 'Las solicitudes de organizador y comisario son analizadas manualmente por el equipo de homologación.',
        global_points: 'Puntos Globales',
        track: 'Pista',
        career_path: 'Trayectoria de Carrera',
        milestone: 'HITO',
        path_description: 'Siga participando en eventos homologados para subir en el ranking global y desbloquear nuevas licencias.',
        become_organizer: 'Quiero ser Organizador',
        become_steward: 'Quiero ser Comisario',
        privacy_title: 'Privacidad y Seguridad',
        account_mgmt_title: 'Gestión de Cuenta (LGPD)',
        account_mgmt_desc: 'Puede optar por <strong>inactivar su cuenta</strong> temporalmente (sus datos no se mostrarán públicamente) ou solicitar a <strong>eliminación definitiva</strong> de sus datos personales, manteniendo solo información anonimizada para fines de integridad competitiva.',
        deactivate_account: 'Inactivar Cuenta',
        deactivate_desc: 'Oculte su perfil temporalmente. Sus datos e historial se preservarán para cuando decida volver.',
        deactivate_btn: 'Sí, Inativar',
        delete_account: 'Eliminar Datos',
        delete_desc: 'Elimine todos sus datos personales permanentemente conforme a la LGPD. Esta acción es irreversible.',
        delete_btn: 'Eliminar Definitivamente',
        deactivate_confirm_title: 'Inactivar Cuenta',
        deactivate_confirm_msg: 'Al inactivar su cuenta, su perfil dejará de ser visible en rankings y listas de pilotos. Su historial competitivo se mantendrá anónimamente. Se desconectará de la plataforma.',
        deactivate_confirm_btn: 'Sí, inactivar',
        delete_confirm_title: 'Eliminación Permanente (LGPD)',
        delete_confirm_msg: 'Atención: Esta acción es irreversible. Todos sus datos personales (nombre, enlaces de redes sociales, correo electrónico) se eliminarán permanentemente de nuestros servidores. Su historial de carreras se anonimizará de forma irreversible. Se desconectará y no podrá recuperar esta cuenta.',
        delete_confirm_btn: 'ELIMINAR PERMANENTEMENTE',
        delete_confirm_word: 'ELIMINAR',
        table_date: 'Fecha',
        table_event: 'Evento',
        table_pos: 'Pos',
        table_sof: 'SoF',
        table_ers: 'eRS',
        connected: 'Conectado',
        cat_turismo: 'Turismo',
        cat_formula: 'Fórmula',
        cat_rally: 'Rally',
      },
      unauthorized: {
        title: 'Acceso Restringido',
        description: 'Solo los usuarios con el rol de Organizador pueden crear nuevas ligas y eventos.',
        request_access: 'Solicitar Acceso',
        back_to_safety: 'Volver a Seguridad'
      },
      teams: {
        title: 'Equipos',
        create: 'Crear Equipo',
        create_title: 'Creación de Equipo',
        subtitle: 'Administre sus equipos, agregue nuevos pilotos o encuentre escuderías competitivas.',
        preview: 'Vista Previa',
        name: 'Nombre del Equipo',
        tag: 'TAG',
        description: 'Descripción',
        logo: 'Logo del Equipo',
        discord_role: 'ID del Rol en Discord',
        submit: 'Crear Equipo',
        tag_hint: '2 a 8 caracteres (A-Z, 0-9)',
        name_placeholder: 'Ej: Scuderia Ferrari',
        desc_placeholder: 'Cuéntanos un poco sobre los orígenes y objetivos de su equipo...',
        tag_placeholder: 'EJ: FER',
        role_placeholder: 'ID del rol para notificaciones automáticas',
        upload_logo: 'Subir logo',
        drivers: 'Pilotos',
        wins: 'Victorias',
        about: 'Sobre el Equipo',
        no_description: 'Este equipo aún no tiene una descripción.',
        request_join: 'Solicitar Ingreso',
        leave: 'Salir del Equipo',
        invite_driver: 'Invitar Piloto',
        invite_message_default: '¡Nos gustaría que te unieras a nuestro equipo!',
        invite_success: '¡Invitación enviada con éxito!',
        invite_error: 'Error al enviar la invitación. El piloto ya puede estar en el equipo o invitado.',
        search_placeholder: 'Buscar por nombre o usuario...',
        no_pilots_found: 'No se encontraron pilotos.',
        member_badge: 'Miembro del Equipo',
        leave_confirm: '¿Estás seguro de que deseas salir de este equipo?',
        leave_success: 'Has salido del equipo.',
        leave_error: 'Error al salir del equipo.',
        team_settings: 'Configuración del Equipo'
      },
      leagues: {
        title: 'Ligas',
        subtitle: 'Explore las ligas de e-motorsport, inscríbase en campeonatos oficiales o administre su propia organización.',
        create: 'Crear Liga',
        create_title: 'Registrar Liga',
        step_1: 'Identidad',
        step_2: 'Configuración',
        step_3: 'Revisión',
        name_label: 'Nombre de la Liga',
        slug_label: 'Slug de la Liga (URL)',
        slug_hint: 'Generado automáticamente para la URL de la liga',
        logo_label: 'Logo de la Liga',
        banner_label: 'Banner (1920x400)',
        privacy: 'Privacidad',
        privacy_public: 'Pública (Todos pueden ver)',
        privacy_private: 'Privada (Solo invitados)',
        regulations: 'Reglamento',
        stewards_title: 'Panel de Stewards',
        stewards_hint: 'Asegure la integridad de las carreras. Mínimo 1 steward.',
        stewards_error_min: 'Se requiere un mínimo de 1 steward.',
        stewards_error_odd: 'Se recomienda un número impar de stewards.',
        add_steward: 'Añadir Steward',
        create_button: 'Crear Liga ✨',
        members: 'Miembros',
        active_events: 'Eventos Activos',
        subscription_section: 'Suscripción',
        no_subscription: 'Sin Suscripción (Gratis)',
        with_subscription: 'Con Suscripción (Premium)',
        subscription_hint: 'Las ligas con suscripción permiten cobros recurrentes a los miembros.',
        subscription_future: 'Disponible pronto',
        access_code: 'Código de Acceso',
        access_code_hint: 'Opcional. Si se define, los usuarios necesitarán este código para unirse a la liga.',
        review_subtitle: 'Revisa antes de crear'
      },
      league_profile: {
        overview: 'Visión General',
        calendar: 'Calendario',
        standings: 'Clasificación',
        teams: 'Equipos',
        stewards: 'Stewards',
        admin: 'Admin',
        next_events: 'Próximos Eventos',
        last_results: 'Últimos Resultados',
        top_pilots: 'Top Pilotos',
        quality_score: 'Quality Score',
        members: 'Seguidores',
        events_count: 'Eventos Realizados',
        trilho_1: 'Trilho 1 (Global)',
        trilho_2: 'Trilho 2 (Liga)',
        no_events: 'No hay eventos programados.',
        auto_promoted: '📢 Divulgado automáticamente',
        create_event: 'Crear Evento',
        about: 'Sobre la Liga',
        no_description: 'Esta liga aún no tiene una descripción.',
        follow: 'Seguir Liga',
        following: 'Siguiendo'
      },
      events_creation: {
        title: 'Crear Evento',
        min_license: 'Licencia Mínima',
        steps: {
          basic_info: 'Información Básica',
          stages_races: 'Etapas y Carreras',
          rules_details: 'Reglas y Detalles'
        },
        info_general: 'Información General',
        info_general_desc: 'Define el nombre, juego y categoría de tu evento.',
        labels: {
          event_title: 'Título del Evento',
          game: 'Simulador / Juego',
          platform: 'Plataforma',
          category: 'Categoría',
          entry_fee: 'Cuota de Inscripción',
          entry_fee_desc: 'Define el valor en e-Tokens',
          event_banner: 'Banner del Evento',
          day_label: 'Etiqueta del Día',
          day_datetime: 'Fecha y Hora del Día',
          circuit_layout: 'Circuito / Trazado',
          allowed_car: 'Coche Permitido',
          race_mode: 'Modo de Carrera',
          laps_count: 'Nº de Vueltas',
          duration_min: 'Duración (min)',
          weather: 'Clima',
          virtual_start: 'Inicio Virtual',
          quali_laps: 'Vueltas Quali',
          race_notes: 'Observaciones de la Carrera',
          race_image: 'Imagen de la Carrera (Portada)',
          registration_requirements: 'Requisitos de Inscripción',
          check_admin_penalties: 'Verificar sanciones administrativas',
          check_admin_penalties_desc: 'Los pilotos con sanciones pendientes en la plataforma no podrán inscribirse.',
          require_minimum_license: 'Exigir licencia mínima',
          require_minimum_license_desc: 'Restringe la participación solo a pilotos calificados.',
          select_license: 'Seleccione la Licencia',
          min_ers: 'eRS Mínimo',
          enable_splits: 'Habilitar Dinámica de Splits',
          enable_splits_desc: 'Divide a los inscritos en múltiples sesiones basadas en el eRS. La división oficial se realizará en el momento en que hagas clic en "Generar Splits".',
          slots_per_split: 'Plazas por Split',
          slots_per_split_desc: 'Define el tamaño de cada parrilla. Ej: Si hay 48 inscritos totales y 24 plazas por split, se generarán 2 splits.',
          total_registration_limit: 'Límite Total de Inscricciones',
          total_registration_limit_desc: 'Define el tope máximo de pilotos que pueden inscribirse en el evento en su totalidad.',
          regulations_details: 'Reglamento & Detalles',
          official_regulations_link: 'Enlace al Reglamento Oficial (Opcional)',
          whatsapp_group_link: 'Enlace al Grupo de WhatsApp (Opcional)',
          car_classes: 'Clases de Coches',
          broadcast_link: 'Enlace de la Transmisión (Opcional)',
          extra_details: 'Instrucciones o Detalles Extras',
          scoring_bonuses: 'Puntuación & Bonos',
          scoring_bonuses_desc: 'Configure puntos extras por desempeño y reglas de puntuación personalizadas.',
          points_pole: 'Puntos por Pole Position',
          points_fastest_lap: 'Puntos por Mejor Vuelta',
          custom_scoring_table: 'Tabla de Puntos Personalizada (Carrera)',
          custom_scoring_table_desc: 'Inserte los puntos separados por comas (Ej: 25, 18, 15, 12, 10...)',
          commission_penalties: 'Comisión & Sanciones',
          commission_penalties_desc: 'Configure los parámetros de sanciones, puntuación por abandono y plazo de defensa para este evento.',
          identification: 'Identificación',
          stages_races_minimal: 'Etapas & Carreras',
          rules: 'Reglas',
          event_status: 'Estado del Evento',
          timezone: 'Zona Horaria',
          scoring_rule: 'Regla de Puntuación',
          custom_scoring_config: 'Configuración de Puntuación',
          race_positions_table: 'Tabla de Posiciones (Carrera)',
          qualy_positions_table: 'Tabla de Posiciones (Qualifying)',
          paid_event: 'Evento pago',
          timezone_brazil: 'Brasil (Brasilia - UTC-3)',
          timezone_usa: 'EE.UU. (Nueva York - UTC-5)',
          timezone_uk: 'Reino Unido (Londres - UTC+0)',
          timezone_france: 'Francia (París - UTC+1)',
          timezone_japan: 'Japón (Tokio - UTC+9)',
          timezone_utc: 'UTC (Tiempo Universal Coordinado)',
          scoring_custom: 'Personalizado',
          scoring_ers: 'Estándar eRS',
          scoring_f1: 'Formato F1',
          scoring_gt: 'Formato GT',
          status_draft: 'Borrador',
          status_published: 'Publicado',
          status_finished: 'Finalizado',
          status_closed: 'Cerrado',
          game_pc: 'PC',
          game_ps5: 'PS5',
          game_xbox: 'Xbox',
          game_cross: 'Cross-platform',
          day_number: 'Día {{number}}',
          race_number: 'Carrera {{number}}',
          upload: 'Subir',
          preview: 'Vista previa',
          start_date: 'Fecha y Hora de Inicio',
          entry_fee_label: 'Cuota de Inscripción',
          tokens: 'Tokens',
          weather_sunny: '☀️ Sol',
          weather_rainy: '🌧️ Lluvia',
          weather_cloudy: '☁️ Nublado',
          weather_variable: '🌦️ Variable',
          private_league_warning: 'Liga privada — eRS no se generará en las carreras de este evento.',
          back: 'Volver',
          save_changes: 'Guardar Cambios',
          saving: 'Guardando...',
          loading_data: 'Cargando datos...',
          error_saving: 'Error al guardar evento',
          error_creating: 'Error al crear evento',
          edit_title: 'Editar Evento',
          settings_difficulty: 'Configuraciones y Dificultad',
          difficulty_label_req: 'Dificultad / Asistencias (Obligatorio)',
          assist_all_allowed_perc: 'Asistencias todas liberadas (80% eRS)',
          assist_partial_perc: 'Asistencias parcialmente liberadas (90% eRS)',
          assist_blocked_perc: 'Asistencias bloqueadas (100% eRS)',
          virtual_categories: 'Categorías Virtuales',
          enable_virtual_categories: 'Habilitar Categorías Virtuales (ej: PRO, AM)'
        },
        placeholders: {
          event_title: 'Ej: Mundial de GT3',
          select_game: 'Seleccione el simulador...',
          select_category: 'Seleccione la categoría...',
          banner_url: 'Pegue el enlace o use el botón de carga al lado',
          day_label: 'Ej: Clasificatorias',
          select_layout: 'Seleccione el trazado...',
          select_car: 'Seleccione el coche...',
          race_notes: 'Reglas específicas, procedimientos, etc...',
          image_url_alt: 'O pegue la URL aquí...',
          select_min_license: 'Elija el nivel mínimo...',
          min_ers: 'Ej: 1500 (0 = sin mínimo)',
          slots_per_split: 'Ej: 24 plazas por parrilla',
          total_registration_limit: 'Ej: 48 (0 = ilimitado)',
          car_classes: 'Ej: GT3, GTE, Prototipos',
          extra_details: 'Inserte detalles sobre briefing, paradas obligatorias, clima...',
          broadcast_url: 'https://youtube.com/live/...',
          scoring_table_desc: 'Inserte los puntos separados por comas (Ej: 25, 18, 15, 12, 10...)',
          banner_drag_drop: 'Haga clic o arrastre para enviar el banner',
          banner_ideal_dim: 'Dimensión ideal: 1200 × 630 px (proporción 16:9)',
          banner_formats_limit: 'Otras dimensiones se ajustan automáticamente · JPG, PNG o WebP · máx 5 MB',
          banner_whatsapp_hint: 'Las imágenes de más de 300 KB se comprenden automáticamente para que funcionen en la vista previa de WhatsApp.',
          uploading_compressing: 'Enviando y comprimiendo...',
          uploading: 'Enviando...',
          ideal_dim_race: '800 × 450 px'
        },
        actions: {
          add_race_to_day: 'Añadir carrera al Día {{day}}',
          add_event_day: 'Añadir nuevo día de evento',
          next_stages: 'Etapas y Carreras',
          next_rules: 'Reglas de Inscripción',
          previous: 'Anterior',
          upload_image: 'Subir Imagen'
        },
        success: {
          banner_uploaded: '¡Banner enviado con éxito!',
          race_image_uploaded: '¡Imagen enviada!',
          create: '¡Evento creado con éxito!',
          edit: '¡Evento actualizado con éxito!'
        },
        errors: {
          banner_upload: 'Error al subir banner: ',
          race_image_upload: 'Error al subir imagen: ',
          create: 'Error al crear evento.',
          edit: 'Error al actualizar evento.'
        },
        validation: {
          missing_fields: 'Falta completar: {{fields}}',
          fill_required: 'Completar los campos obligatorios.',
          missing_race_details: 'Falta completar: Pista, Coche y Vueltas en TODAS las etapas/carreras configuradas.',
        },
        warnings: {
          private_league: 'Liga privada — eRS no se generará en las carreras de este evento.',
          past_date: 'La fecha debe ser en el futuro para eventos publicados. Use el estado "Borrador" para crear o editar eventos con fechas retroactivas.',
        }
      },
      results_posting: {
        title: 'Lanzamiento de Resultados',
        session: 'Sesión',
        save_draft: 'Guardar Borrador',
        publish: 'Publicar y Calcular eRS',
        irreversible: 'Esta acción es IRREVERSIBLE. El eRS de los pilotos se recalculará globalmente.',
        pos: 'Pos.',
        pilot: 'Piloto',
        time: 'Tiempo/Intervalo',
        penalty: 'Pen.',
        delta: 'eRS Delta',
        status_draft: 'Borrador',
        status_final: 'Finalizado',
        confirm_title: '¿Confirmar Publicación?',
        success_title: '¡Resultados Publicados!'
      },
      incidents: {
        title: 'Enviar Incidente',
        subtitle: 'Informe los incidentes de pista con precisión para su revisión por parte de los Stewards.',
        type_collision: 'Colisión / Toque',
        type_limits: 'Límite de Pista',
        type_conduct: 'Conducta Antideportiva',
        type_rejoin: 'Regreso Peligroso',
        type_flags: 'Ignorar Banderas',
        type_other: 'Otros',
        session: 'Sesión / Carrera',
        lap: 'Vuelta del Incidente',
        reported_pilot: 'Piloto Reportado',
        description: 'Descripción Detallada',
        description_hint: 'Describa los hechos con claridad (mínimo 50 caracteres).',
        evidence: 'Enlace de Evidencia (Cualquier Enlace / Vídeo)',
        submit: 'Enviar Incidente',
        success: '¡Incidente enviado con éxito! Espere el veredicto de los comisarios.',
        incident_type: 'Tipo de Incidente'
      },
      stewardship: {
        title: 'Panel de Comisarios',
        pending: 'Incidentes Pendientes',
        total: 'Total de Casos',
        urgent: 'Urgente',
        voted: 'Votado',
        votes: 'Votos',
        consensus: 'Consenso Alcanzado',
        penalize: 'Penalizar',
        dismiss: 'Archivar',
        review: 'En Revisión',
        points: 'Puntos',
        penalty_light: 'Leve',
        penalty_medium: 'Media',
        penalty_grave: 'Pesada',
        penalty_gravissimo: 'Gravísima',
        verdict: 'Veredicto Final',
        stewards_count: '{{count}} Comisarios Activos',
        dashboard: 'Panel Global',
        my_assignments: 'Mis Asignaciones',
        global_analysis: 'Análisis Global de Incidentes',
        track_incidents: 'Incidentes en Pista',
        administration: 'ADMINISTRACIÓN',
        reported_by: 'Reportado por:',
        reported_pilot: 'Acusado:',
        video_evidence: 'Evidencia en Vídeo',
        open_external_player: 'Abrir Reproductor Externo',
        vote_tally: 'Recuento de Votos ({{current}}/{{total}})',
        your_vote: 'Tu Voto',
        severity_points: 'Gravedad y Puntos',
        pts: 'pts',
        confirm_vote: 'Confirmar Voto',
        case_closed: 'Caso Cerrado',
        verdict_consolidated: 'Veredicto consolidado. No se permite ninguna nueva votación.',
        no_incidents: 'Ningún incidente',
        fair_play: 'Los pilotos se están comportando muy bien en la pista hoy.',
        analytics: 'Análisis',
        resolved: 'Resueltos',
        consensus_avg: 'Consenso Medio',
        urgency: 'Urgencia',
        cases: 'Casos',
        steward_team: 'Equipo de Comisarios',
        system_active: 'SISTEMA ACTIVO',
        lap_short: 'VUELTA',
        pilot_report: 'Relato del Piloto',
        digital_evidence: 'Evidencia Digital',
        watch_replay: 'VER REPLAY DEL INCIDENTE',
        no_evidence: 'Ninguna evidencia visual adjunta a este informe.',
        assigned_stewards: 'Stewards Asignados',
        decision_panel: 'Panel de Decisión',
        quorum: 'QUÓRUM: {{current}} / {{total}}',
        justification_history: 'Historial de Justificaciones',
        panel_member: 'Miembro del Panel',
        no_justification: 'Ninguna justificación proporcionada.',
        severity_label: 'GRAVEDAD:',
        points_label: 'PUNTOS:',
        justification_placeholder: 'Justifique su veredicto técnicamente basándose en las reglas de la liga...',
        confirm_final_verdict: 'CONFIRMAR VEREDICTO FINAL',
        observer_mode: 'MODO OBSERVADOR',
        observer_desc: 'Usted tiene acceso a este panel como organizador, pero el tratamiento técnico es exclusivo de los stewards designados para el quórum de este evento.',
        final_verdict: 'VEREDICTO FINAL',
        voted_successfully: 'Voto Procesado',
        vote_registered_desc: 'Su contribución ha sido registrada en el sistema central de justicia de la liga.',
        process_closed: 'Proceso Cerrado',
        download_ris: 'DESCARGAR INFORME RIS (PDF)'
      },
      event_details: {
        about: 'Sobre el Evento',
        schedule: 'Cronograma Completo',
        cars: 'Máquinas',
        no_cars: 'Ningún carro listado.',
        no_schedule: 'Ninguna etapa configurada todavía.',
        day: 'Día',
        duration: 'Duración',
        laps: '{{count}} Vueltas',
        car: 'Coche',
        organizer_panel: 'Panel Organizador',
        edit: 'Editar',
        delete: 'Eliminar',
        delete_confirm: '¿Está seguro de que desea eliminar este evento? Esta acción no se puede deshacer.',
        delete_success: 'Evento eliminado con éxito.',
        min_ers: 'eRS Mínimo',
        min_license: 'Licencia Mínima',
        status: 'Estado',
        regulations: 'Reglamento Oficial',
        organizer_notes: 'Notas del Organizador',
        no_details: 'Ningún detalle adicional proporcionado por el organizador.',
        free: 'Libre',
        view_pilots: 'Ver Pilotos',
        pilot_list: 'Lista de Pilotos Inscritos',
        pilot_name: 'Nombre del Piloto',
        no_pilots: 'Ningún piloto inscrito todavía.',
        send_announcement_title: 'Enviar Aviso a los Inscritos',
        send_announcement_desc: 'Escriba un mensaje rápido e importante. Se enviará instantáneamente como una notificación en el panel de todos los pilotos inscritos en este evento.',
        send_announcement_placeholder: 'Ej: ¡Briefing obligatorio a las 20h! Sala de discord #briefing-sala-1...',
        send_announcement_char_count: '{{count}} / 140 caracteres',
        send_announcement_btn: 'Enviar Aviso',
        send_announcement_btn_sending: 'Enviando...',
        send_announcement_success: '¡Aviso enviado a los inscritos con éxito!',
        send_announcement_error: 'Por favor, escriba un mensaje para enviar el aviso.'
      },
      registration: {
        title: 'Inscripciones',
        registered: 'Inscrito',
        register: 'Inscribirse',
        unregister: 'Cancelar Inscripción',
        success: '¡Inscripción confirmada! Buena suerte en la pista.',
        unregister_success: 'Inscripción cancelada con éxito.',
        error: 'Error al realizar la inscripción.',
        limit: '{{count}} / {{total}} Pilotos',
        unlimited: '{{count}} / ∞ Pilotos',
        critical: 'ÚLTIMAS PLAZAS',
        full: 'COMPLETO',
        open: 'ABIERTO'
      },
      settings: {
        title: 'Ajustes de Usuario',
        subtitle: 'Administre su perfil y preferencias globales',
        profile: 'Perfil',
        appearance: 'Apariencia',
        appearance_title: 'Interfaz y Tema',
        appearance_subtitle: 'Elija cómo desea visualizar la plataforma',
        theme_label: 'Esquema de Colores',
        theme_desc: 'Actualmente en modo {{theme}}',
        theme_dark: 'Oscuro',
        theme_light: 'Claro',
        midnight: 'Modo Nocturno',
        daylight: 'Modo Diurno',
        language_title: 'Idioma de la Interfaz',
        language_subtitle: 'Elija el idioma predeterminado para la consola',
        integrations: 'Integraciones',
        integrations_title: 'Integraciones Externas',
        integrations_subtitle: 'Vincule sus cuentas para sincronizar datos',
        notifications: 'Notificaciones',
        notifications_title: 'Centro de Notificaciones',
        notifications_subtitle: 'Controle cómo y cuándo ser alertado',
        bank_title: 'Datos Financieros',
        agents_tab: 'Agentes',
        bank_subtitle: 'La edición de datos financieros estará disponible pronto después de la validación de identidad.',
        avatar_label: 'Avatar de Piloto',
        avatar_hint: 'Sincronizado vía Google o Personalizado',
        personal_data: 'Datos Personales',
        notif_session: 'Inicio de Sesión',
        notif_session_desc: 'Alertas 15 minutos antes de la bandera verde',
        notif_incidents: 'Incidentes de Pista',
        notif_incidents_desc: 'Notificaciones de protestas y penalizaciones',
        notif_announcements: 'Anuncios de la Liga',
        notif_announcements_desc: 'Cambios en el calendario y reglamentos',
        notif_chat: 'Chat de Equipo',
        notif_chat_desc: 'Mensajes directos de tus compañeros',
        bank_holder: 'Titular de la Cuenta',
        bank_name: 'Banco',
        bank_pix: 'Clave PIX',
        language_label: 'Idioma de la Interfaz',
        language_desc: 'Elija el idioma predeterminado para la consola',
        regional_language: 'Regional e Idioma',
        priority_game: 'Juego Prioritario',
        priority_game_desc: 'Este juego se cargará de forma predeterminada al iniciar la consola.',
        select_game: 'Selecciona un juego',
        privacy: 'Privacidad y Datos',
        privacy_title: 'Gestión de Privacidad',
        privacy_subtitle: 'Controla tus datos y visibilidad en la plataforma',
        select_country: 'Selecciona tu país...',
        nickname: 'Nickname',
        nickname_placeholder: 'Ej: Ayrton Senna',
        bio: 'Bio',
        location: 'Ubicación',
        save_changes: 'Guardar Cambios',
        success: '¡Guardado con éxito!',
        save_error: 'Error al guardar. Inténtalo de nuevo.',
        slug_hint: 'Tu @slug se actualizará automáticamente según tu Apodo.',
        select_placeholder: 'Seleccione...',
        saving: 'Guardando...',
        google_linked: 'Google Vinculado (Obligatorio)',
        discord: 'Discord',
        steam: 'Steam',
      },
      onboarding: {
        title: 'Bienvenido a e-MSS',
        subtitle: 'Para comenzar tu carrera, necesitamos algo de información básica.',
        nationality: 'Nacionalidad',
        priority_game: '¿Cuál es tu juego principal?',
        start_career: 'Comenzar mi Carrera',
        nickname: 'Tu Nickname en la Plataforma',
        nickname_placeholder: 'Ej: Ayrton Senna',
        nickname_hint: 'Este es el nombre que aparece en resultados, rankings y ligas. Usa el mismo apodo que utilizas en los juegos para facilitar tu identificación por los organizadores.',
        nickname_already_correct: 'Mi nickname ya es correcto — continuar'
      },
      manager: {
        title: 'Gestor',
        subtitle: 'Gestión centralizada de la plataforma e-Motorsport Series. Control total de usuarios, activos y reglas.',
        stats: {
          users: 'Usuarios',
          leagues: 'Ligas',
          events: 'Eventos',
          teams: 'Equipos',
          sessions: 'Sesiones'
        },
        tabs: {
          dashboard: 'Métricas',
          users: 'Usuarios',
          tracks: 'Pistas',
          cars: 'Coches',
          events: 'Eventos',
          leagues: 'Ligas',
          rules: 'Reglas',
          sandbox: 'Sandbox',
          commission: 'Comisión',
          schedule: 'Agenda'
        },
        commission: {
          title: 'Parametrización de la Comisión',
          subtitle: 'Gestión de Scoring y Sanciones',
          search_event: 'Buscar evento...',
          select_event: 'Seleccionar un Evento',
          save_success: '¡Parámetros de comisión guardados con éxito!',
          save_error: 'Error al guardar los parámetros de comisión.',
          warning: 'Estos ajustes afectan directamente la puntuación bruta de la sesión y el flujo de la comisión de la liga. Los cambios durante un evento en curso pueden generar inconsistencias en los datos históricos.',
          penalty_ranges: 'Rango de Puntos por Severidad',
          light: 'Leve',
          medium: 'Medio',
          grave: 'Grave',
          gravissimo: 'Gravísimo',
          dnf_points_title: 'Puntuación DNF (Abandono)',
          dnf_points_desc: 'Define la regla de puntuación para pilotos que no completen la prueba',
          dnf_enabled: 'Puntuación Normal',
          dnf_enabled_desc: 'El piloto recibe puntos proporcionales a su posición final, aunque abandone.',
          dnf_fixed: 'Valor Fijo / Nerfado',
          dnf_fixed_desc: 'La puntuación se limita a un valor fijo definido por ti para cualquier DNF.',
          deadline_safety: 'Plazo para Defensa',
          deadline_desc: 'Determina cuánto tiempo tiene el piloto para impugnar sanciones',
          deadline_days: 'Total en días',
          report_deadline_title: 'Plazo para Reportes',
          report_deadline_desc: 'Tiempo máximo después de la carrera para enviar denuncias de incidentes',
          scoring_tabs: {
            penalties: 'Sanciones',
            results: 'Puntuación',
            deadlines: 'Plazos'
          },
          errors: {
            invalid_range: 'El valor mínimo del rango no puede ser mayor que el máximo.'
          }
        },
        events: {
          title: 'Gestión de Eventos',
          active: 'Activos'
        },
        leagues: {
          title: 'Salud de las Ligas',
          active: 'Activas'
        },
        rules: {
          title: 'Gestión de Reglas',
          subtitle: 'Control de Acceso Administrativo',
          revoke: 'Revocar',
          assign: 'Asignar',
          loading: 'Cargando permisos...'
        },
        dashboard: {
          growth: 'Crecimiento de la Plataforma',
          alerts: 'Alertas del Sistema',
          placeholder_chart: 'Gráfico de usuarios y sesiones (Placeholder)'
        },
        users: {
          title: 'Gestionar Pilotos',
          search_placeholder: 'Buscar por nombre, @username o e-mail...'
        },
        schedule: {
          title: 'Agenda Semanal',
          tab: 'Agenda',
          filter_game: 'Filtrar por Juego',
          all_games: 'Todos los Juegos',
          week_label: '{{start}} – {{end}} · {{year}}',
          prev_week: 'Semana Anterior',
          next_week: 'Próxima Semana',
          current_week: 'Semana Actual',
          no_races: 'Sin carreras',
          send_discord: 'Enviar al Discord',
          sending: 'Enviando...',
          discord_success: '¡Agenda enviada al Discord con éxito!',
          discord_error: 'Error al enviar la agenda al Discord.',
          preview_title: 'Vista previa — Agenda Semanal',
          events_count_one: '{{count}} evento',
          events_count_other: '{{count}} eventos'
        }
      },

      results: {
        validation: {
          pos_invalid: 'Posición inválida para el piloto {{name}}. Debe estar entre 1 y 99.',
          best_lap_invalid: 'Formato de mejor vuelta inválido para el piloto {{name}}. Usa MM:SS,000.',
          laps_invalid: 'Vueltas completadas inválidas para el piloto {{name}}. Debe ser un número entero no negativo.',
          total_time_invalid: 'Formato de tiempo total inválido para el piloto {{name}}. Usa MM:SS,000.',
        },
        placeholder_pilot: 'Piloto',
        day_label: 'Día {{day}}',
        search_placeholder: 'Escribe el nombre o apodo del piloto...',
        no_pilot_found: 'Ningún piloto encontrado.',
        add_pilot_btn: 'Añadir Piloto a la Parrilla',
        empty_grid_title: 'Parrilla vacía',
        empty_grid_desc: 'Añada los pilotos usando el botón de arriba o buscando por nombre/apodo',
        table: {
          pos: 'POS.',
          pilot: 'PILOTO',
          best_lap: 'MEJOR VUELTA',
          total_time: 'TIEMPO TOTAL',
          distance: 'DISTANCIA',
          laps: 'VUELTAS',
          status: 'ESTADO'
        },
        legend: {
          title: 'ESTADO DE PRESENCIA',
          registered: 'El piloto participó y completó la carrera normalmente.',
          dns: 'El piloto estaba inscrito, pero no comenzó (no participó en la carrera).',
          dnf: 'El piloto comenzó la carrera, pero no la terminó (abandono o rotura).',
          dsq: 'El piloto fue descalificado por alguna infracción técnica o deportiva.'
        }
      },
      history_page: {
        subtitle: 'Historial completo de desempeño',
        pos_history: 'Historial de Posiciones',
        ers_performance: 'Rendimiento eRS',
        insufficient_data: 'Datos insuficientes',
        all_races: 'Todas las Carreras',
        results: 'Resultados',
        results_count: '{{count}} Resultados',
        table: {
          date: 'Fecha',
          event: 'Evento',
          pos: 'Pos',
          sof: 'SoF',
          ers: 'eRS',
          no_races: 'Ninguna carrera registrada en el historial.',
        },
        },
        league_admin: {
          panel_title: 'ADMINISTRACIÓN',
          panel_subtitle: 'Gestión completa de su liga.',
          general_settings: 'CONFIGURACIÓN',
          general_settings_desc: 'Edite nombre, descripción, logotipos y reglas.',
          edit_league: 'EDITAR LIGA',
          co_organizers: 'PERSONAL Y ADMINISTRADORES',
          co_organizers_desc: 'Añada o elimine permisos de organización.',
          remove_co_organizer: 'Eliminar permiso',
          search_users: 'Buscar piloto...',
          danger_zone: 'ÁREA CRÍTICA',
          danger_zone_desc: 'Acciones irreversibles como eliminar la liga.',
          delete_league: 'ELIMINAR LIGA'
        },
        agents: {
          title: 'AGENTES',
          subtitle: 'Instale el agente en su PC para enviar telemetría automática a las carreras.',
          pairing_title: 'EMPAREJAMIENTO',
          pairing_desc: 'Genere un código e ingréselo en el agente (icono de bandeja → Emparejar). El código expira en 15 minutos.',
          generate: 'GENERAR CÓDIGO',
          regenerate: 'GENERAR NUEVO CÓDIGO',
          code_label: 'CÓDIGO DE EMPAREJAMIENTO',
          expires_in: 'Expira en',
          copy: 'COPIAR',
          copied: '¡Copiado!',
          devices_title: 'DISPOSITIVOS EMPAREJADOS',
          devices_empty: 'Aún no hay dispositivos emparejados.',
          last_seen: 'Último envío',
          never: 'Nunca',
          active: 'Activo',
          inactive: 'Inactivo',
          revoke: 'REVOCAR',
          delete: 'ELIMINAR',
          revoke_confirm_used: '¿Revocar "{{name}}"? El dispositivo dejará de enviar telemetría (historial conservado).',
          revoke_confirm_unused: '¿Eliminar "{{name}}"? Este emparejamiento nunca envió datos y se eliminará definitivamente.',
          revoked: 'Dispositivo revocado.',
          download_title: 'DESCARGA',
          download_desc: 'Agente ligero en segundo plano para el PC de simulación. Soporta Forza Motorsport y AMS 2 / PCars2 (UDP).',
          download: 'DESCARGAR AGENTE (Windows)',
          download_android_title: 'ANDROID',
          download_android_desc: 'APK para el celular en la misma red del simulador. Al instalar, autoriza "fuentes desconocidas" y empareja con el código.',
          download_android: 'DESCARGAR AGENTE (Android)',
          steps_title: 'CÓMO FUNCIONA',
          step_1: '1. Descargue e instale el agente en su PC de simulación.',
          step_2: '2. Genere un código aquí e ingréselo en el agente para emparejar.',
          step_3: '3. Corra como siempre — la telemetría se envía automáticamente.',
          step_4: '4. Las sesiones aparecen en las etapas y en su historial.'
        },
        telemetry: {
          title: 'TELEMETRÍA',
          no_sessions: 'Aún no hay sesiones enviadas',
          empty: 'Esta sesión no tiene muestras suficientes para analizar.',
          load_error: 'Error al cargar la sesión.',
          laps: 'VUELTAS',
          lap: 'Vuelta',
          time: 'Tiempo',
          ref_short: 'Ref',
          partial: 'parcial',
          full_lap: 'Vuelta completa',
          map: 'MAPA',
          map_hint: 'Rueda del ratón = zoom · arrastrar = mover · doble clic = reset',
          map_modes: { lines: 'Líneas de las vueltas', dlt: 'Ganancia/pérdida (Δ)' },
          channels_title: 'CANALES',
          charts_hint: 'Rueda = zoom · arrastrar = mover · doble clic = reset · ratón = sincroniza',
          follow_car: 'Seguir coche',
          play: 'Play',
          pause: 'Pausar',
          space_hint: 'espacio = play/pause',
          invalid: 'inválida',
          ideal_lap: 'Vuelta ideal (mejores sectores)',
          comparative: 'COMPARATIVO',
          baseline: 'Línea base del Δ',
          baseline_opt: 'OPT',
          baseline_best: 'Mejor',
          baseline_pace: 'Pace',
          baseline_short: 'BASE',
          opt: 'OPT',
          opt_full: 'Vuelta óptima (costura de los mejores sectores)',
          pace: 'Pace',
          pace_full: 'Pace (media por sector)',
          best_full: 'Mejor vuelta de la sesión',
          history: 'HISTORIAL DE VUELTAS',
          no_sectors: 'Esta sesión no tiene datos de sectores por vuelta (lotes antiguos del agente).',
          summary: 'RESUMEN DE VUELTAS SELECCIONADAS',
          sum: {
            vmax: 'V máx',
            vmin: 'V mín',
            vavg: 'V méd',
            thr: 'Acel. total',
            brk: 'Freno',
            coast: 'S-pedal (coast)',
          },
          compare: 'Comparar con…',
          compare_title: 'COMPARAR CON OTRO PILOTO',
          compare_hint: 'Sesiones enviadas por otros pilotos en el mismo circuito. Elige cargar su OPT (costura de los mejores sectores) o su mejor vuelta.',
          compare_load: 'Cargando sesiones…',
          compare_empty: 'Ninguna sesión de otro piloto en este circuito.',
          compare_active: 'Comparando con',
          compare_remove: 'Quitar',
          compare_load_error: 'No se pudo cargar — sesión sin vuelta válida o sin sectores.',
          compare_not_comparable: 'Comparación no disponible — pista, coche o evento diferentes.',
          compare_search: 'Buscar por gamertag o nombre…',
          compare_max_pilots: 'Máximo de 3 pilotos en la comparación — quita uno para incluir otro.',
          compare_in_comparison: 'en la comparación',
          compare_pro_lock: 'Comparar con otro piloto es un recurso del plan Piloto PRO',
          compare_pro_title: 'LA COMPARACIÓN ES UN RECURSO PRO',
          compare_pro_hint: 'La comparación entre pilotos (coche + pista + tipo de sesión) es exclusiva del plan Piloto PRO. Tus sesiones y vueltas siguen disponibles gratis.',
          compare_pro_cta: 'Suscribirse a Piloto PRO',
          active_lines: 'LÍNEAS ACTIVAS',
          hide_line: 'Ocultar/mostrar esta línea',
          remove_line: 'Quitar de la comparación',
          samples: 'muestras',
          channels: {
            delta: 'Delta (s)',
            spd: 'Velocidad (km/h)',
            pedals: 'Pedales (▲ acel · ▼ freno)',
            thr: 'Acelerador (%)',
            brk: 'Freno (%)',
            gear: 'Marcha',
            rpm: 'RPM',
          }
        }
      }
    },
  'en': {
    translation: {
      common: {
        login: 'Login',
        logout: 'Sign Out',
        entrar: 'Join the Track',
        ranking: 'View Ranking',
        back: 'Back',
        previous: 'Previous',
        next: 'Next',
        next_step: 'Next Step',
        loading: 'Loading...',
        saving: 'Saving...',
        save_changes: 'Save Changes',
        create_event: 'Create Event',
        read_more: 'Read more',
        view_details: 'View details',
        coming_soon: 'Coming soon',
        privacy: 'Privacy',
        maintenance: 'Under Maintenance',
        close: 'Close',
        cancel: 'Cancel',
        hours: 'Hours',
        days: 'Days',
        day: 'Day',
        race: 'Race',
        laps: 'Laps',
        time: 'Time',
        upload: 'Upload',
        upload_image: 'Upload Image',
        free: 'Free',
        paid_tokens: 'Paid (e-Tokens)',
        value: 'Value',
        cross_platform: 'Cross-platform',
        success: 'Success',
        error: 'Error',
        independent: 'Independent',
        independent_league: 'Independent League',
        fill_all_fields: 'Please fill in all fields.'
      },
      marbles: {
        title: 'Marbles Balance',
        wallet_button: 'Marbles Wallet',
        loading: 'Loading...',
        error: 'Error loading balance',
        error_history: 'Error loading statement',
        retry: 'Try again',
        empty: 'No transactions yet',
        history_title: 'Statement',
        view_full: 'View full statement',
        private_note: 'Only you can see this balance',
        settings_tab: 'Wallet',
        settings_title: 'Marbles Wallet',
        settings_subtitle: 'Your balance and all account transactions',
        tx: {
          deposit: 'Deposit',
          admin_grant: 'Platform credit',
          event_entry_fee: 'Entry fee',
          refund: 'Refund',
          event_prize: 'Event prize',
          platform_prize: 'Platform prize',
          ecommerce_purchase: 'Marketplace purchase',
          withdrawal_hold: 'Withdrawal in progress',
          withdrawal_cancelled: 'Withdrawal cancelled',
          admin_deduction: 'Platform adjustment'
        }
      },
      pages: {
        landing: {
          upcomingEvents: 'Upcoming Championships',
          viewAllLeagues: 'View All Leagues',
          registeredPilots: 'Registered Drivers',
          completedRaces: 'Completed Races',
          enterPlatform: 'Enter Platform'
        },
        dashboard: {
          overview: 'Overview',
          myRegistrations: 'My Registrations',
          tokenBalance: 'e-Token Balance',
          seasonStats: 'Season Statistics',
          nextRace: 'Next Race'
        },
        league: {
          about: 'About the League',
          activeSeasons: 'Active Championships',
          followers: 'Followers',
          follow: 'Follow League',
          regulations: 'Internal Regulations',
          organizedBy: 'Organized by'
        },
        event: {
          openRegistrations: 'Open Registrations',
          grid: 'Starting Grid',
          briefing: 'Race Briefing',
          allowedCars: 'Allowed Cars',
          slotsRemaining: 'Slots Remaining',
          register: 'Register'
        },
        results: {
          saveResults: 'Save Results',
          publishStandings: 'Publish Standings',
          penalties: 'Applied Penalties',
          fastestLap: 'Fastest Lap',
          disqualified: 'Disqualified (DSQ)',
          uploadTelemetry: 'Upload Telemetry'
        }
      },
      pwa: {
        install_ios: "Tap Share and 'Add to Home Screen' for a native experience.",
        install_android: "Install e-MSS on your home screen for quick access.",
        install_button: "Install App",
        ios_alert: "To install on iOS: tap the Share button in the Safari bottom bar and select 'Add to Home Screen'."
      },
      privacy_modal: {
        title: 'Privacy Update',
        description: 'To continue ensuring the security of your data and compliance with data protection regulations, we need you to review and accept our Privacy Policy.',
        read_button: 'Read Privacy Policy',
        checkbox_label: 'I read and agree to the terms',
        checkbox_hint: 'By proceeding, you authorize e-MSS to process your essential data for maintaining your sports profile, race history, and necessary integrations, as described in the document.',
        accept_button: 'Accept and Continue',
        saving: 'Saving...',
        success: 'Privacy Policy accepted successfully.',
        error: 'Error saving your preferences.',
        error_required: 'You must accept the Privacy Policy to continue.',
        footer_note: 'e-MSS Privacy Protocol • V{{version}}'
      },
      promotion_modal: {
        congratulations: 'CONGRATULATIONS, DRIVER!',
        title: 'LICENSE PROMOTION',
        subtitle: '{{name}}, you have leveled up on the platform.',
        demotion_header: 'LICENSE UPDATE',
        demotion_title: 'LICENSE RECLASSIFICATION',
        demotion_subtitle: '{{name}}, your platform license has been adjusted.',
        from: 'FROM',
        to: 'TO',
        description: 'Your consistency and commitment have been recognized. License {{tier}} opens new opportunities and high-level events for you.',
        demotion_description: 'Your driver license has been adjusted to License {{tier}}. Keep competing to move back up.',
        cta: 'Celebrate and Continue',
        aria_label: 'License Change Modal'
      },
      maintenance: {
        pill: 'PIT STOP',
        eyebrow: 'Scheduled maintenance',
        title_top: 'DOWN',
        title_bottom: 'FOR SERVICE',
        lead: 'The platform is going through a technical intervention to take e-MSS to the next performance level. Your driver, your rating and your entire history stay intact — back shortly.',
        status_value: 'System offline',
        clock_label: 'Paddock clock',
        cta_secondary: 'Talk to the crew',
        note_title: 'Thanks for your patience',
        note_body: 'Already published results, ratings and Safety Wallets are unaffected. Questions and reports are still being handled on our Discord.',
        support: 'emsseries@gmail.com',
        footer_brand: 'e-Motorsport Series',
        footer_legal: 'Virtual Motorsport Platform'
      },
      landing: {
        hero: {
          season: 'COMPETITION PLATFORM',
          title: 'Turn your league into a real competition',
          subtitle: 'Organize events, rankings, and results in a system where the driver evolves, competes, and returns.',
          sim_racing: 'Sim Racing Console',
          fh6: 'Forza Horizon 6 Console'
        },
        problem: {
          title: 'Most leagues get stuck here',
          items: [
            'Manual spreadsheets',
            'Result errors',
            'Incident disputes',
            'Rankings without credibility'
          ],
          closing: "It's not a lack of drivers. It's a lack of structure."
        },
        stats: {
          pilots: 'Registered drivers',
          events: 'Active events',
          orgs: 'Running leagues'
        },
        sections: {
          events: 'See how a structured league works',
          ranking: 'Global Ranking',
          wallets: 'Digital Wallets',
          orgs: 'Top Orgs'
        },
        feed: {
          title: 'LIVE COMPETITIONS',
          explore: 'Explore events',
          drivers: 'drivers',
          slots: 'slots',
          final_phase: 'final phase'
        },
        value: {
          title: 'When the driver cares, the league grows',
          text: 'When the driver sees evolution, ranking, and history,\nthey return.\n\nAnd when they return, the competition grows.\n\nThat is what transforms a common league into a strong one.',
          points: [
            'Rating that changes every race',
            'Full driver history',
            'Reliable and updated ranking',
            'Structured incident system'
          ]
        },
        trust: {
          title: 'Leagues already evolving with the EMSS standard'
        },
        pilot_path: {
          title: 'Every corner builds your legacy',
          subtitle: 'Your e-Motorsport career now has an official record. From kart to prototype, your history follows you.',
          items: [
            {
              title: 'Digital License',
              text: 'Your license evolves based on your safety and speed on track.'
            },
            {
              title: 'Global Rating',
              text: 'The eRS (Electronic Rating System) ensures you race against those at your level.'
            },
            {
              title: 'Eternal History',
              text: 'Access results from years ago in seconds. Your history is not lost in WhatsApp groups.'
            }
          ]
        },
        segment: {
          organizer: {
            title: 'For organizers',
            text: 'Professionalize your league and increase driver engagement without relying on spreadsheets.'
          },
          pilot: {
            title: 'For drivers',
            text: 'Track your evolution, build history, and see your performance impact the ranking.'
          },
          sponsor: {
            title: 'For supporters',
            text: 'Connect your brand to organized competitions and engaged drivers.'
          }
        },
        cta: {
          title: 'Your drivers are waiting for something better',
          button: 'Start my league now'
        }
      },
      login: {
        title: 'JOIN THE TRACK',
        subtitle: 'Sign in with your Google account to start your virtual career',
        google: 'Continue with Google',
        terms: 'By signing in, you agree to the Terms of Use'
      },
      console: {
        dashboard: 'Dashboard',
        events: 'Events',
        ranking: 'Ranking',
        garage: 'Garage',
        settings: 'Settings',
        stewardship: 'Commission',
        help: 'Help',
        online: 'Drivers Online',
        rating: 'Your eRS',
        track: 'Go to Track',
        support: 'Support',
        logout: 'Logout',
        back_to_site: 'Back to Site',
        search: 'Search events...',
        category: 'Category',
        license: 'License',
        game: 'Game',
        reset: 'Reset Filters',
        overview: 'Overview',
        welcome: 'Welcome back',
        next_event: 'NEXT EVENT',
        all: 'ALL',
        practice: 'PRACTICE',
        qualifying: 'QUALIFYING',
        race: 'RACE',
        my_leagues: 'MY LEAGUES',
        no_leagues_followed: 'You are not following any leagues yet. Explore leagues to receive updates.',
        game_selector_disabled: 'Game selector unavailable on this screen',
        cycle: {
          week: 'Week',
          tooltip: '{{label}} — Week {{week}} of {{total}}',
        },
        notifications: {
          title: 'Notifications',
          mark_all_read: 'Mark all as read',
          no_notifications: 'No new notifications',
          view_all: 'View all',
          incident_reported: 'Incident Reported',
          verdict_published: 'Verdict Published',
          steward_assignment: 'New Assignment',
          new_league: 'New League Created',
          new_event: 'New Event Created',
          new_user: 'New Driver Registered'
        }
      },
      pilot_console: {
        safety_ers: 'eRS',
        driver_rank: 'Driver Rank',
        recommended: 'RECOMMENDED',
        confirmed: 'CONFIRMED',
        registrations_open: 'REGISTRATIONS OPEN',
        enter_server: 'Enter Server',
        no_highlight: 'No featured event',
        time_to_green: 'Time to Green Flag',
        waiting_next: 'Waiting for Next Event',
        days: 'DAYS',
        hours: 'HRS',
        minutes: 'MIN',
        seconds: 'SEC',
        races_completed: 'Races Completed',
        podiums: 'Podiums',
        avg_finish: 'Avg. Finish',
        full_telemetry: 'Full Telemetry Analysis',
        my_roster: 'My Leagues',
        my_calendar: 'My Calendar',
        syncing: 'Syncing...',
        no_active_registrations: 'No active registrations',
        upcoming_races: 'Upcoming Races',
        followed_leagues_races: 'LEAGUES YOU FOLLOW',
        community: 'COMMUNITY',
        no_races_available: 'No other races available at the moment',
        quick_links: 'Quick Links',
        discord_community: 'Discord Community',
        race_regulations: 'Race Regulations',
        pending_defenses: 'Pending Defenses',
        pending_defenses_desc: 'Protests involving you that require your attention or defense within the deadline.',
        no_pending_defenses: 'Great! You have no pending defenses.',
        present_defense: 'Present Defense',
        defense_deadline_ended: 'Deadline ended',
        defense_alert_title: 'Attention: you have a pending accusation awaiting defense',
        defense_alert_desc: 'An incident has been filed against you and is awaiting your statement. Submit your defense within the deadline so the commission can review your side of the story.',
        defense_time_remaining: '{{hours}}h {{minutes}}min left',
        defense_deadline_label: 'DEFENSE DEADLINE',
        defense_deadline_warning: 'The technical deadline to submit your defense ended on {{date}}. The form remains available: you can still register your version of the events, but the commission will review a late submission.',
        defense_deadline_warning_generic: 'The technical deadline to submit your defense has ended. The form remains available: you can still register your version of the events, but the commission will review a late submission.',
        series_standings: 'Series Standings',
        built_for_speed: 'Built for Speed.',
        date: 'Date',
        circuit: 'Circuit',
        enter_race: 'Enter Race',
        hot_topic: 'Hot Topic',
        driver_dashboard: 'DRIVER DASHBOARD',
        race_started: 'RACE IN PROGRESS',
        race_in_progress: 'RACE IN PROGRESS',
        race_title: 'Race Title',
        cars: 'Cars',
        tracks: 'Tracks',
        cat: 'Cat.',
        dur: 'Dur.',
        lic: 'Lic.',
        starts_in: 'Countdown',
      },
      profile: {
        title: 'Driver Profile',
        career: 'Career',
        stats: 'Statistics',
        integrations: 'Integrations',
        avgPos: 'Average Position',
        sessions: 'Sessions',
        wins: 'Wins',
        podiums: 'Podiums',
        total: 'TOTAL',
        win_rate: 'WIN RATE',
        podium_rate: 'PODIUM RATE',
        rank_label: 'RANKING',
        points_suffix: 'PTS',

        unlink: 'Unlink',
        link: 'Link',
        unlink_confirm: 'Are you sure you want to unlink your Discord?',
        discord_success: 'Discord linked successfully!',
        accountDeactivated: 'Account deactivated successfully.',
        deactivateError: 'Error deactivating account.',
        accountDeleted: 'Account permanently deleted.',
        deleteError: 'Error deleting account.',
        no_races_found: 'No races recorded.',
        history: 'Race History',
        license_history: 'License History',
        rate: 'Rate',
        become_request_hint: 'Organizer and steward requests are analyzed manually by the homologation team.',
        global_points: 'Global Points',
        track: 'Track',
        career_path: 'Career Path',
        milestone: 'MILESTONE',
        path_description: 'Continue participating in sanctioned events to climb the global ranking and unlock new licenses.',
        become_organizer: 'I want to be an Organizer',
        become_steward: 'I want to be a Steward',
        privacy_title: 'Privacy and Security',
        account_mgmt_title: 'Account Management (GDPR/LGPD)',
        account_mgmt_desc: 'You can choose to <strong>deactivate your account</strong> temporarily (your data will not be displayed publicly) or request the <strong>permanent deletion</strong> of your personal data, keeping only anonymized information for competitive integrity purposes.',
        deactivate_account: 'Deactivate Account',
        deactivate_desc: 'Hide your profile temporarily. Your data and history will be preserved for when you decide to return.',
        deactivate_btn: 'Yes, Deactivate',
        delete_account: 'Delete Data',
        delete_desc: 'Permanently remove all your personal data in accordance with GDPR/LGPD. This action is irreversible.',
        delete_btn: 'Delete Permanently',
        deactivate_confirm_title: 'Deactivate Account',
        deactivate_confirm_msg: 'By deactivating your account, your profile will no longer be visible in rankings and driver lists. Your competitive history will be maintained anonymously. You will be signed out of the platform.',
        deactivate_confirm_btn: 'Yes, deactivate',
        delete_confirm_title: 'Permanent Deletion (GDPR/LGPD)',
        delete_confirm_msg: 'Warning: This action is irreversible. All your personal data (name, social media links, email) will be permanently deleted from our servers. Your race history will be irreversibly anonymized. You will be signed out and will not be able to recover this account.',
        delete_confirm_btn: 'DELETE PERMANENTLY',
        delete_confirm_word: 'DELETE',
        table_date: 'Date',
        table_event: 'Event',
        table_pos: 'Pos',
        table_sof: 'SoF',
        table_ers: 'eRS',
        connected: 'Connected',
        cat_turismo: 'Touring',
        cat_formula: 'Formula',
        cat_rally: 'Rally',
      },
      unauthorized: {
        title: 'Restricted Access',
        description: 'Only users with the Organizer role can create new leagues and events.',
        request_access: 'Request Access',
        back_to_safety: 'Back to Safety'
      },
      teams: {
        title: 'Teams',
        create: 'Create Team',
        create_title: 'Team Creation',
        subtitle: 'Manage your teams, add new drivers or find competitive racing teams.',
        preview: 'Team Preview',
        name: 'Team Name',
        tag: 'TAG',
        description: 'Description',
        logo: 'Team Logo',
        discord_role: 'Discord Role ID',
        submit: 'Create Team',
        tag_hint: '2 to 8 characters (A-Z, 0-9)',
        name_placeholder: 'Ex: Scuderia Ferrari',
        desc_placeholder: 'Tell us a bit about your team\'s origins and goals...',
        tag_placeholder: 'EX: FER',
        role_placeholder: 'Role ID for automated notifications',
        upload_logo: 'Upload logo',
        drivers: 'Drivers',
        wins: 'Wins',
        about: 'About the Team',
        no_description: 'This team does not have a description yet.',
        request_join: 'Request to Join',
        leave: 'Leave Team',
        invite_driver: 'Invite Driver',
        invite_message_default: 'We would like you to join our team!',
        invite_success: 'Invitation sent successfully!',
        invite_error: 'Error sending invitation. Driver might already be in the team or invited.',
        search_placeholder: 'Search by name or username...',
        no_pilots_found: 'No drivers found.',
        member_badge: 'Team Member',
        leave_confirm: 'Are you sure you want to leave this team?',
        leave_success: 'You have left the team.',
        leave_error: 'Error leaving the team.',
        team_settings: 'Team Settings'
      },
      leagues: {
        title: 'Leagues',
        subtitle: 'Explore e-motorsport leagues, sign up for official championships or manage your own organization.',
        create: 'Create League',
        create_title: 'Register League',
        step_1: 'Identity',
        step_2: 'Configuration',
        step_3: 'Review',
        name_label: 'League Name',
        name_placeholder: 'Ex: Virtual Racing Association',
        slug_label: 'League Slug (URL)',
        slug_hint: 'Automatically generated for the league URL',
        logo_label: 'League Logo',
        banner_label: 'Banner (1920x400)',
        privacy: 'Privacy',
        privacy_public: 'Public (Everyone can see)',
        privacy_private: 'Private (Invite only)',
        desc_placeholder: 'Tell us a bit about the origins, championships and goals of your organization...',
        regulations: 'Regulations',
        stewards_title: 'Stewards Panel',
        stewards_hint: 'Ensure racing integrity. Minimum 1 steward.',
        stewards_error_min: 'Minimum of 1 steward required.',
        stewards_error_odd: 'An odd number of stewards is recommended.',
        add_steward: 'Add Steward',
        create_button: 'Create League ✨',
        members: 'Members',
        active_events: 'Active Events',
        subscription_section: 'Subscription',
        no_subscription: 'No Subscription (Free)',
        with_subscription: 'With Subscription (Premium)',
        subscription_hint: 'Subscription leagues allow recurring billing for members.',
        subscription_future: 'Coming soon',
        access_code: 'Access Code',
        access_code_hint: 'Optional. If set, users will need this code to join the league.',
        review_subtitle: 'Review before creating'
      },
      league_profile: {
        overview: 'Overview',
        calendar: 'Calendar',
        standings: 'Standings',
        teams: 'Teams',
        stewards: 'Stewards',
        admin: 'Admin',
        next_events: 'Upcoming Events',
        last_results: 'Recent Results',
        top_pilots: 'Top Drivers',
        quality_score: 'Quality Score',
        members: 'Followers',
        events_count: 'Events Held',
        trilho_1: 'Track 1 (Global)',
        trilho_2: 'Track 2 (League)',
        no_events: 'No events scheduled.',
        auto_promoted: '📢 Auto-promoted',
        create_event: 'Create Event',
        about: 'About the League',
        no_description: 'This league does not have a description yet.',
        no_events_yet: 'No upcoming events scheduled.',
        view_all_standings: 'View Full Standings',
        regulations: 'Regulations',
        no_seasons_yet: 'No seasons registered.',
        not_found: 'League not found',
        not_found_desc: 'The league you are looking for does not exist or has been removed.',
        browse_leagues: 'Browse Leagues',
        no_standings: 'No standings available.',
        admin_panel: 'Admin Panel',
        admin_desc: 'Manage your league settings and members',
        restricted_access: 'Owner Restricted Access',
        follow: 'Follow League',
        following: 'Following'
      },
      events_creation: {
        title: 'Create Event',
        min_license: 'Min License',
        steps: {
          basic_info: 'Basic Info',
          stages_races: 'Stages & Races',
          rules_details: 'Rules & Details'
        },
        info_general: 'General Information',
        info_general_desc: 'Define the name, game, and category of your event.',
        labels: {
          event_title: 'Event Title',
          game: 'Game',
          category: 'Category',
          event_type: 'Event Type',
          platform: 'Platform',
          entry_fee: 'Entry Fee',
          entry_fee_desc: 'Define the value in e-Tokens',
          event_banner: 'Event Banner',
          day_label: 'Day Label',
          day_datetime: 'Day Date and Time',
          circuit_layout: 'Circuit / Layout',
          allowed_car: 'Allowed Car',
          race_mode: 'Race Mode',
          laps_count: 'Nº of Laps',
          duration_min: 'Duration (min)',
          weather: 'Weather',
          virtual_start: 'Virtual Start',
          quali_laps: 'Quali Laps',
          race_notes: 'Race Observations',
          race_image: 'Race Image (Cover)',
          registration_requirements: 'Registration Requirements',
          check_admin_penalties: 'Check administrative penalties',
          check_admin_penalties_desc: 'Drivers with pending penalties on the platform will not be allowed to register.',
          require_minimum_license: 'Require minimum license',
          require_minimum_license_desc: 'Restricts participation only to qualified drivers.',
          select_license: 'Select License',
          min_ers: 'Minimum eRS',
          enable_splits: 'Enable Splits Dynamics',
          enable_splits_desc: 'Divides registrants into multiple sessions based on eRS. Official splitting will occur when you click "Generate Splits".',
          slots_per_split: 'Slots per Split',
          slots_per_split_desc: 'Defines the size of each grid. Ex: If there are 48 total registrants and 24 slots per split, 2 splits will be generated.',
          total_registration_limit: 'Total Registration Limit',
          total_registration_limit_desc: 'Defines the maximum cap of drivers that can register for the overall event.',
          regulations_details: 'Regulations & Details',
          official_regulations_link: 'Official Regulations Link (Optional)',
          whatsapp_group_link: 'WhatsApp Group Link (Optional)',
          car_classes: 'Car Classes',
          broadcast_link: 'Broadcast Link (Optional)',
          extra_details: 'Instructions or Extra Details',
          scoring_bonuses: 'Scoring & Bonuses',
          scoring_bonuses_desc: 'Configure extra points for performance and custom scoring rules.',
          points_pole: 'Points for Pole Position',
          points_fastest_lap: 'Points for Mixed/Fastest Lap',
          custom_scoring_table: 'Custom Scoring Table (Race)',
          custom_scoring_table_desc: 'Insert points separated by commas (Ex: 25, 18, 15, 12, 10...)',
          commission_penalties: 'Commission & Penalties',
          commission_penalties_desc: 'Configure penalty parameters, retirement scoring, and defense deadline for this event.',
          identification: 'Identification',
          stages_races_minimal: 'Stages & Races',
          rules: 'Rules',
          event_status: 'Event Status',
          timezone: 'Timezone',
          scoring_rule: 'Scoring Rule',
          custom_scoring_config: 'Scoring Configuration',
          race_positions_table: 'Positions Table (Race)',
          qualy_positions_table: 'Positions Table (Quali)',
          paid_event: 'Paid event',
          timezone_brazil: 'Brazil (Brasilia - UTC-3)',
          timezone_usa: 'USA (New York - UTC-5)',
          timezone_uk: 'UK (London - UTC+0)',
          timezone_france: 'France (Paris - UTC+1)',
          timezone_japan: 'Japan (Tokyo - UTC+9)',
          timezone_utc: 'UTC (Universal Coordinated Time)',
          scoring_custom: 'Custom',
          scoring_ers: 'Standard eRS',
          scoring_f1: 'F1 Format',
          scoring_gt: 'GT Format',
          status_draft: 'Draft',
          status_published: 'Published',
          status_finished: 'Finished',
          status_closed: 'Closed',
          game_pc: 'PC',
          game_ps5: 'PS5',
          game_xbox: 'Xbox',
          game_cross: 'Cross-platform',
          day_number: 'Day {{number}}',
          race_number: 'Race {{number}}',
          upload: 'Upload',
          preview: 'Preview',
          start_date: 'Start Date and Time',
          entry_fee_label: 'Entry Fee',
          tokens: 'Tokens',
          weather_sunny: '☀️ Sunny',
          weather_rainy: '🌧️ Rainy',
          weather_cloudy: '☁️ Cloudy',
          weather_variable: '🌦️ Variable',
          private_league_warning: 'Private league — eRS will not be generated in races for this event.',
          back: 'Back',
          save_changes: 'Save Changes',
          saving: 'Saving...',
          loading_data: 'Loading data...',
          error_saving: 'Error saving event',
          error_creating: 'Error creating event',
          edit_title: 'Edit Event',
          settings_difficulty: 'Settings & Difficulty',
          difficulty_label_req: 'Difficulty / Assists (Required)',
          assist_all_allowed_perc: 'All assists allowed (80% eRS)',
          assist_partial_perc: 'Assists partially allowed (90% eRS)',
          assist_blocked_perc: 'Assists disabled (100% eRS)',
          virtual_categories: 'Virtual Categories',
          enable_virtual_categories: 'Enable Virtual Categories (ex: PRO, AM)'
        },
        placeholders: {
          event_title: 'Ex: GT3 World Championship',
          select_game: 'Select simulator...',
          select_category: 'Select category...',
          banner_url: 'Paste link or use upload button beside',
          day_label: 'Ex: Qualifying',
          select_layout: 'Select layout...',
          select_car: 'Select car...',
          race_notes: 'Specific rules, procedures, etc...',
          image_url_alt: 'Or paste URL here...',
          select_min_license: 'Choose minimum level...',
          min_ers: 'Ex: 1500 (0 = no minimum)',
          slots_per_split: 'Ex: 24 slots per grid',
          total_registration_limit: 'Ex: 48 (0 = unlimited)',
          car_classes: 'Ex: GT3, GTE, Prototypes',
          extra_details: 'Insert details about briefing, mandatory pits, weather...',
          broadcast_url: 'https://youtube.com/live/...',
          scoring_table_desc: 'Insert points separated by commas (Ex: 25, 18, 15, 12, 10...)',
          banner_drag_drop: 'Click or drag to upload the banner',
          banner_ideal_dim: 'Ideal dimension: 1200 × 630 px (16:9 aspect ratio)',
          banner_formats_limit: 'Other dimensions are adjusted automatically · JPG, PNG or WebP · max 5 MB',
          banner_whatsapp_hint: 'Images larger than 300 KB are automatically compressed to work in WhatsApp link previews.',
          uploading_compressing: 'Uploading and compressing...',
          uploading: 'Uploading...',
          ideal_dim_race: '800 × 450 px'
        },
        actions: {
          add_race_to_day: 'Add race to Day {{day}}',
          add_event_day: 'Add new event day',
          next_stages: 'Stages & Races',
          next_rules: 'Registration Rules',
          previous: 'Previous',
          upload_image: 'Upload Image'
        },
        success: {
          banner_uploaded: 'Banner uploaded successfully!',
          race_image_uploaded: 'Image uploaded!',
          create: 'Event created successfully!',
          edit: 'Event updated successfully!'
        },
        errors: {
          banner_upload: 'Error uploading banner: ',
          race_image_upload: 'Error uploading image: ',
          create: 'Error creating event.',
          edit: 'Error updating event.'
        },
        validation: {
          missing_fields: 'Missing fields: {{fields}}',
          fill_required: 'Fill in required fields.',
          missing_race_details: 'Missing details: Track, Car, and Laps in ALL configured stages/races.',
        },
        warnings: {
          private_league: 'Private league — eRS will not be generated in races for this event.',
          past_date: 'The date must be in the future for published events. Use the "Draft" status to create or edit events with past dates.',
        }
      },
      results_posting: {
        title: 'Post Results',
        session: 'Session',
        save_draft: 'Save Draft',
        publish: 'Publish & Calculate eRS',
        irreversible: 'This action is IRREVERSIBLE. Pilot eRS will be recalculated globally.',
        pos: 'Pos.',
        pilot: 'Pilot',
        time: 'Time/Gap',
        penalty: 'Pen.',
        delta: 'eRS Delta',
        status_draft: 'Draft',
        status_final: 'Finalized',
        confirm_title: 'Confirm Publication?',
        success_title: 'Results Published!'
      },
      incidents: {
        title: 'Report Incident',
        subtitle: 'Report track incidents accurately for Stewards review.',
        type_collision: 'Collision / Contact',
        type_limits: 'Track Limits',
        type_conduct: 'Unsportsmanlike Conduct',
        type_rejoin: 'Dangerous Rejoin',
        type_flags: 'Ignoring Flags',
        type_other: 'Other',
        session: 'Session / Race',
        lap: 'Incident Lap',
        reported_pilot: 'Reported Pilot',
        description: 'Detailed Description',
        description_hint: 'Clearly describe the facts (minimum 50 characters).',
        evidence: 'Evidence Link (Any Link / Video)',
        submit: 'Submit Incident',
        success: 'Incident submitted successfully! Wait for the stewards\' verdict.',
        incident_type: 'Incident Type'
      },
      stewardship: {
        title: 'Stewards Panel',
        pending: 'Pending Incidents',
        total: 'Total Cases',
        urgent: 'Urgent',
        voted: 'Voted',
        votes: 'Votes',
        consensus: 'Consensus Reached',
        penalize: 'Penalize',
        dismiss: 'Dismiss',
        review: 'Reviewing',
        points: 'Points',
        penalty_light: 'Light',
        penalty_medium: 'Medium',
        penalty_grave: 'Severe',
        penalty_gravissimo: 'Critical',
        verdict: 'Final Verdict',
        stewards_count: '{{count}} Active Stewards',
        dashboard: 'Global Dashboard',
        my_assignments: 'My Assignments',
        global_analysis: 'Global Incident Analysis',
        track_incidents: 'Track Incidents',
        administration: 'ADMINISTRATION',
        reported_by: 'Reported by:',
        reported_pilot: 'Accused:',
        video_evidence: 'Video Evidence',
        open_external_player: 'Open External Player',
        vote_tally: 'Vote Tally ({{current}}/{{total}})',
        your_vote: 'Your Vote',
        severity_points: 'Severity & Points',
        pts: 'pts',
        confirm_vote: 'Confirm Vote',
        case_closed: 'Case Closed',
        verdict_consolidated: 'Verdict consolidated. No new voting allowed.',
        no_incidents: 'No incidents',
        fair_play: 'Drivers are behaving very well on track today.',
        analytics: 'Analytics',
        resolved: 'Resolved',
        consensus_avg: 'Avg Consensus',
        urgency: 'Urgency',
        cases: 'Cases',
        steward_team: 'Stewards Team',
        system_active: 'SYSTEM ACTIVE',
        lap_short: 'LAP',
        pilot_report: 'Driver Report',
        digital_evidence: 'Digital Evidence',
        watch_replay: 'WATCH INCIDENT REPLAY',
        no_evidence: 'No visual evidence attached to this report.',
        assigned_stewards: 'Assigned Stewards',
        decision_panel: 'Decision Panel',
        quorum: 'QUORUM: {{current}} / {{total}}',
        justification_history: 'Justification History',
        panel_member: 'Panel Member',
        no_justification: 'No justification provided.',
        severity_label: 'SEVERITY:',
        points_label: 'POINTS:',
        justification_placeholder: 'Justify your verdict technically based on league rules...',
        confirm_final_verdict: 'CONFIRM FINAL VERDICT',
        observer_mode: 'OBSERVER MODE',
        observer_desc: 'You have access to this panel as an organizer, but technical processing is exclusive to the stewards assigned to the quorum for this event.',
        final_verdict: 'FINAL VERDICT',
        voted_successfully: 'Voted Successfully',
        vote_registered_desc: 'Your contribution has been registered in the league central justice system.',
        process_closed: 'Process Closed',
        download_ris: 'DOWNLOAD RIS REPORT (PDF)',
        steward_panel: 'STEWARD PANEL',
        subtitle: 'Analyze evidence, register your technical votes and collaborate to maintain competition integrity.',
        analytics_title: 'PERFORMANCE ANALYTICS',
        avg_quorum: 'AVG QUORUM',
        response_time: 'RESPONSE TIME',
        filters: 'QUICK FILTERS',
        all: 'All',
        collision: 'Collision',
        track_limits: 'Track Limits',
        conduct: 'Conduct',
        incident_report: 'INCIDENT REPORT',
        judgment_panel: 'JUDGMENT PANEL',
        voting_progress: 'VOTING PROGRESS',
        finalize_points: 'CONSOLIDATE POINTS & CLOSE',
        waiting_quorum: 'WAITING QUORUM ({{current}} / {{total}})',
        suggested_severity: 'SUGGESTED SEVERITY',
        penalty_points: 'PENALTY POINTS',
        confirm_verdict: 'CONFIRM VERDICT',
        case_closed_desc: 'The final verdict has been consolidated and penalties have been applied to the drivers involved.',
        view_report: 'VIEW OFFICIAL REPORT',
        generating_pdf: 'GENERATING PDF...',
        generate_report: 'GENERATE RIS REPORT',
        clean_track: 'CLEAN TRACK',
        no_pending: 'There are no pending incidents assigned to you at the moment.',
        error_loading_assignments: 'Failed to load assignments.',
        error_loading_details: 'Error loading incident details.',
        error_registering_vote: 'Failed to register vote.',
        confirm_consolidate_desc: 'Are you sure you want to consolidate this verdict? This will apply penalties and close the case.',
        error_consolidating: 'Failed to consolidate incident.',
        error_generating_report: 'Failed to generate report. Check server logs.',
        vote_registered: 'Vote registered successfully!',
        vote_error: 'Failed to register vote.',
        loading_assignments: 'LOADING ASSIGNMENTS...',
        abstain: 'Abstain'
      },
      event_details: {
        about: 'About the Event',
        schedule: 'Full Schedule',
        cars: 'Machines',
        no_cars: 'No cars listed.',
        no_schedule: 'No stages configured yet.',
        day: 'Day',
        duration: 'Duration',
        laps: '{{count}} Laps',
        car: 'Car',
        organizer_panel: 'Organizer Panel',
        edit: 'Edit',
        delete: 'Delete',
        delete_confirm: 'Are you sure you want to delete this event? This action cannot be undone.',
        delete_success: 'Event deleted successfully.',
        min_rating: 'Min eRS',
        min_license: 'Min License',
        status: 'Status',
        regulations: 'Official Regulations',
        organizer_notes: 'Organizer Notes',
        no_details: 'No additional details provided by the organizer.',
        free: 'Free',
        view_pilots: 'View Pilots',
        pilot_list: 'Registered Pilots List',
        pilot_name: 'Pilot Name',
        no_pilots: 'No pilots registered yet.',
        send_announcement_title: 'Send Announcement to Registered Drivers',
        send_announcement_desc: 'Write a quick and important message. It will be immediately sent as a notification to all registered drivers of this event.',
        send_announcement_placeholder: 'Ex: Mandatory briefing at 8 PM! Discord room #briefing-room-1...',
        send_announcement_char_count: '{{count}} / 140 characters',
        send_announcement_btn: 'Send Announcement',
        send_announcement_btn_sending: 'Sending...',
        send_announcement_success: 'Announcement successfully sent to registered drivers!',
        send_announcement_error: 'Please enter a message to send the announcement.'
      },
      registration: {
        title: 'Registrations',
        registered: 'Registered',
        register: 'Register',
        unregister: 'Cancel Registration',
        success: 'Registration confirmed! Good luck on track.',
        unregister_success: 'Registration cancelled successfully.',
        error: 'Error during registration.',
        limit: '{{count}} / {{total}} Drivers',
        unlimited: '{{count}} / ∞ Drivers',
        critical: 'LAST SLOTS',
        full: 'FULL',
        open: 'OPEN'
      },
      settings: {
        title: 'User Settings',
        subtitle: 'Manage your profile and global preferences',
        profile: 'Profile',
        appearance: 'Appearance',
        appearance_title: 'Interface and Theme',
        appearance_subtitle: 'Choose how you want to view the platform',
        theme_label: 'Color Scheme',
        theme_desc: 'Currently in {{theme}} mode',
        theme_dark: 'Dark',
        theme_light: 'Light',
        midnight: 'Midnight Mode (Dark)',
        daylight: 'Daylight Mode (Light)',
        language_title: 'Interface Language',
        language_subtitle: 'Choose the default language for the console',
        integrations: 'Integrations',
        integrations_title: 'External Integrations',
        integrations_subtitle: 'Link your accounts to sync data',
        notifications: 'Notifications',
        notifications_title: 'Notification Center',
        notifications_subtitle: 'Control how and when you are alerted',
        bank_title: 'Financial Data',
        agents_tab: 'Agents',
        bank_subtitle: 'Editing financial data will be available soon after identity validation.',
        avatar_label: 'Driver Avatar',
        avatar_hint: 'Synced via Google or Custom',
        personal_data: 'Personal Information',
        notif_session: 'Session Start',
        notif_session_desc: 'Alerts 15 minutes before the green flag',
        notif_incidents: 'Track Incidents',
        notif_incidents_desc: 'Notifications of protests and penalties',
        notif_announcements: 'League Announcements',
        notif_announcements_desc: 'Changes in the calendar and regulations',
        notif_chat: 'Team Chat',
        notif_chat_desc: 'Direct messages from your teammates',
        nickname: 'Nickname',
        nickname_placeholder: 'Ex: Ayrton Senna',
        bio: 'Bio',
        location: 'Location',
        save_changes: 'Save Changes',
        success: 'Saved successfully!',
        save_error: 'Error saving. Try again.',
        slug_hint: 'Your @slug will be automatically updated based on your Nickname.',
        select_placeholder: 'Select...',
        saving: 'Saving...',
        google_linked: 'Google Linked (Required)',
        discord: 'Discord',
        steam: 'Steam',
        bank_holder: 'Account Holder',
        bank_name: 'Bank',
        bank_pix: 'PIX Key / Payment Key',
        language_label: 'Interface Language',
        language_desc: 'Choose the default language for the console',
        regional_language: 'Regional & Language',
        priority_game: 'Priority Game',
        priority_game_desc: 'This game will be loaded by default when starting the console.',
        select_game: 'Select a game',
        privacy: 'Privacy & Data',
        privacy_title: 'Privacy Management',
        privacy_subtitle: 'Control your data and visibility on the platform',
        select_country: 'Select your country...'
      },

      onboarding: {
        title: 'Welcome to e-MSS',
        subtitle: 'To start your career, we need some basic information.',
        nationality: 'Nationality',
        priority_game: 'What is your primary game?',
        start_career: 'Start my Career',
        nickname: 'Your Platform Nickname',
        nickname_placeholder: 'Ex: Ayrton Senna',
        nickname_hint: 'This is the name displayed on results, rankings, and leagues. Use the same alias you use in-game so organizers can easily find you.',
        nickname_already_correct: 'My nickname is already correct — continue'
      },
      manager: {
        title: 'Manager',
        subtitle: 'Centralized management of the e-Motorsport Series platform. Total control of users, assets, and rules.',
        stats: {
          users: 'Users',
          leagues: 'Leagues',
          events: 'Events',
          teams: 'Teams',
          sessions: 'Sessions'
        },
        tabs: {
          dashboard: 'Metrics',
          users: 'Users',
          tracks: 'Tracks',
          cars: 'Cars',
          events: 'Events',
          leagues: 'Leagues',
          rules: 'Rules',
          sandbox: 'Sandbox',
          commission: 'Commission',
          schedule: 'Schedule'
        },
        commission: {
          title: 'Commission Settings',
          subtitle: 'Scoring & Penalty Management',
          search_event: 'Search event...',
          select_event: 'Select an Event',
          save_success: 'Commission settings saved successfully!',
          save_error: 'Error saving commission settings.',
          warning: 'These settings directly affect the session raw score and the league commission workflow. Changes during an ongoing event may cause inconsistencies in historical data.',
          penalty_ranges: 'Points Range by Severity',
          light: 'Light',
          medium: 'Medium',
          grave: 'Serious',
          gravissimo: 'Very Serious',
          dnf_points_title: 'DNF Scoring (Retirement)',
          dnf_points_desc: 'Define the scoring rule for drivers who do not complete the race',
          dnf_enabled: 'Normal Scoring',
          dnf_enabled_desc: 'The driver receives points proportional to their final position, even if they retire.',
          dnf_fixed: 'Fixed / Nerfed Value',
          dnf_fixed_desc: 'The score is capped at a fixed value you define for any DNF.',
          deadline_safety: 'Defense Deadline',
          deadline_desc: 'Set how long drivers have to contest penalties',
          deadline_days: 'Total in days',
          report_deadline_title: 'Report Deadline',
          report_deadline_desc: 'Maximum time after the race to submit incident reports',
          scoring_tabs: {
            penalties: 'Penalties',
            results: 'Scoring',
            deadlines: 'Deadlines'
          },
          errors: {
            invalid_range: 'The minimum range value cannot be greater than the maximum.'
          }
        },
        events: {
          title: 'Events Management',
          active: 'Active'
        },
        leagues: {
          title: 'Leagues Health',
          active: 'Active'
        },
        rules: {
          title: 'Rules Management',
          subtitle: 'Admin Access Control',
          revoke: 'Revoke',
          assign: 'Assign',
          loading: 'Loading permissions...'
        },
        dashboard: {
          growth: 'Platform Growth',
          alerts: 'System Alerts',
          placeholder_chart: 'User and sessions chart (Placeholder)'
        },
        users: {
          title: 'Manage Drivers',
          search_placeholder: 'Search by name, @username or email...'
        },
        schedule: {
          title: 'Weekly Schedule',
          tab: 'Schedule',
          filter_game: 'Filter by Game',
          all_games: 'All Games',
          week_label: '{{start}} – {{end}} · {{year}}',
          prev_week: 'Previous Week',
          next_week: 'Next Week',
          current_week: 'Current Week',
          no_races: 'No races',
          send_discord: 'Send to Discord',
          sending: 'Sending...',
          discord_success: 'Schedule sent to Discord successfully!',
          discord_error: 'Error sending schedule to Discord.',
          preview_title: 'Preview — Weekly Schedule',
          events_count_one: '{{count}} event',
          events_count_other: '{{count}} events'
        }
      },
      results: {
        validation: {
          pos_invalid: 'Invalid position for driver {{name}}. Must be between 1 and 99.',
          best_lap_invalid: 'Invalid best lap format for driver {{name}}. Use MM:SS,000.',
          laps_invalid: 'Invalid laps completed for driver {{name}}. Must be a non-negative integer.',
          total_time_invalid: 'Invalid total time format for driver {{name}}. Use MM:SS,000.',
        },
        placeholder_pilot: 'Driver',
        day_label: 'Day {{day}}',
        search_placeholder: 'Type driver name or username...',
        no_pilot_found: 'No driver found.',
        add_pilot_btn: 'Add Driver to Grid',
        empty_grid_title: 'Empty Grid',
        empty_grid_desc: 'Add drivers using the button above or searching by name/username',
        table: {
          pos: 'POS.',
          pilot: 'DRIVER',
          best_lap: 'BEST LAP',
          total_time: 'TOTAL TIME',
          distance: 'DISTANCE',
          laps: 'LAPS',
          status: 'STATUS'
        },
        legend: {
          title: 'ATTENDANCE STATUS',
          registered: 'The driver participated and completed the race normally.',
          dns: 'The driver was registered but did not start (did not participate in the race).',
          dnf: 'The driver started the race but did not finish (retirement or mechanical failure).',
          dsq: 'The driver was disqualified due to a technical or sporting infraction.'
        }
      },
      history_page: {
        subtitle: 'Complete performance history',
        pos_history: 'Position History',
        ers_performance: 'eRS Performance',
        insufficient_data: 'Insufficient data',
        all_races: 'All Races',
        results: 'Results',
        results_count: '{{count}} Results',
        table: {
          date: 'Date',
          event: 'Event',
          pos: 'Pos',
          sof: 'SoF',
          ers: 'eRS',
          no_races: 'No races recorded in history.',
        },
        },
        league_admin: {
          panel_title: 'ADMINISTRATION',
          panel_subtitle: 'Complete management of your league.',
          general_settings: 'SETTINGS',
          general_settings_desc: 'Edit name, description, logos and rules.',
          edit_league: 'EDIT LEAGUE',
          co_organizers: 'STAFF & ADMINS',
          co_organizers_desc: 'Add or remove organization permissions.',
          remove_co_organizer: 'Remove permission',
          search_users: 'Search pilot...',
          danger_zone: 'CRITICAL AREA',
          danger_zone_desc: 'Irreversible actions such as deleting the league.',
          delete_league: 'DELETE LEAGUE'
        },
        agents: {
          title: 'AGENTS',
          subtitle: 'Install the agent on your PC to automatically send telemetry to races.',
          pairing_title: 'PAIRING',
          pairing_desc: 'Generate a code and enter it in the agent (tray icon → Pair). The code expires in 15 minutes.',
          generate: 'GENERATE CODE',
          regenerate: 'GENERATE NEW CODE',
          code_label: 'PAIRING CODE',
          expires_in: 'Expires in',
          copy: 'COPY',
          copied: 'Copied!',
          devices_title: 'PAIRED DEVICES',
          devices_empty: 'No paired devices yet.',
          last_seen: 'Last upload',
          never: 'Never',
          active: 'Active',
          inactive: 'Inactive',
          revoke: 'REVOKE',
          delete: 'DELETE',
          revoke_confirm_used: 'Revoke "{{name}}"? The device stops sending telemetry (history kept).',
          revoke_confirm_unused: 'Delete "{{name}}"? This pairing never sent data and will be permanently removed.',
          revoked: 'Device revoked.',
          download_title: 'DOWNLOAD',
          download_desc: 'Lightweight background agent for your sim PC. Supports Forza Motorsport and AMS 2 / PCars2 (UDP).',
          download: 'DOWNLOAD AGENT (Windows)',
          download_android_title: 'ANDROID',
          download_android_desc: 'APK for your phone on the same network as the sim. When installing, allow "unknown sources" and pair with the code.',
          download_android: 'DOWNLOAD AGENT (Android)',
          steps_title: 'HOW IT WORKS',
          step_1: '1. Download and install the agent on your sim PC.',
          step_2: '2. Generate a code here and enter it in the agent to pair.',
          step_3: '3. Race as always — telemetry is sent automatically.',
          step_4: '4. Sessions appear in events and in your history.'
        },
        telemetry: {
          title: 'TELEMETRY',
          no_sessions: 'No sessions uploaded yet',
          empty: 'This session does not have enough samples to analyze.',
          load_error: 'Error loading session.',
          laps: 'LAPS',
          lap: 'Lap',
          time: 'Time',
          ref_short: 'Ref',
          partial: 'partial',
          full_lap: 'Full lap',
          map: 'MAP',
          map_hint: 'Mouse wheel = zoom · drag = move · double-click = reset',
          map_modes: { lines: 'Lap lines', dlt: 'Gain/loss (Δ)' },
          channels_title: 'CHANNELS',
          charts_hint: 'Wheel = zoom · drag = move · double-click = reset · hover = sync',
          follow_car: 'Follow car',
          play: 'Play',
          pause: 'Pause',
          space_hint: 'space = play/pause',
          invalid: 'invalid',
          ideal_lap: 'Ideal lap (best sectors)',
          comparative: 'COMPARATIVE',
          baseline: 'Δ baseline',
          baseline_opt: 'OPT',
          baseline_best: 'Best',
          baseline_pace: 'Pace',
          baseline_short: 'BASE',
          opt: 'OPT',
          opt_full: 'Optimal lap (stitched from best sectors)',
          pace: 'Pace',
          pace_full: 'Pace (average per sector)',
          best_full: 'Best lap of the session',
          history: 'LAP HISTORY',
          no_sectors: 'This session has no per-sector data (legacy agent batches).',
          summary: 'SELECTED LAPS SUMMARY',
          sum: {
            vmax: 'Max speed',
            vmin: 'Min speed',
            vavg: 'Avg speed',
            thr: 'Throttle',
            brk: 'Brake',
            coast: 'Coast',
          },
          compare: 'Compare with…',
          compare_title: 'COMPARE WITH ANOTHER DRIVER',
          compare_hint: 'Sessions uploaded by other drivers on the same track. Choose to load their OPT (stitched from best sectors) or their best lap.',
          compare_load: 'Loading sessions…',
          compare_empty: 'No sessions from other drivers on this track.',
          compare_active: 'Comparing with',
          compare_remove: 'Remove',
          compare_load_error: 'Could not load — session has no valid lap or no sectors.',
          compare_not_comparable: 'Comparison unavailable — different track, car, or event.',
          compare_search: 'Search by gamertag or name…',
          compare_max_pilots: 'Up to 3 drivers in the comparison — remove one to add another.',
          compare_in_comparison: 'in comparison',
          active_lines: 'ACTIVE LINES',
          hide_line: 'Hide/show this line',
          remove_line: 'Remove from comparison',
          samples: 'samples',
          channels: {
            delta: 'Delta (s)',
            spd: 'Speed (km/h)',
            pedals: 'Pedals (▲ thr · ▼ brk)',
            thr: 'Throttle (%)',
            brk: 'Brake (%)',
            gear: 'Gear',
            rpm: 'RPM',
          }
        }
      }
    }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt-BR',
    interpolation: {
      escapeValue: false,
    }
  });

export default i18n;
